// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function(modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      return newRequire(localRequire.resolve(x));
    }

    function resolve(x) {
      return modules[name][1][x] || x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function(id, exports) {
    modules[id] = [
      function(require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function() {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function() {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"gXND3":[function(require,module,exports) {
var HMR_HOST = null;
var HMR_PORT = null;
var HMR_SECURE = false;
var HMR_ENV_HASH = "1293bae57ac04db4";
module.bundle.HMR_BUNDLE_ID = "55cfa9cf2e12d888";
"use strict";
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {
            };
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/* global HMR_HOST, HMR_PORT, HMR_ENV_HASH, HMR_SECURE */ /*::
import type {
  HMRAsset,
  HMRMessage,
} from '@parcel/reporter-dev-server/src/HMRServer.js';
interface ParcelRequire {
  (string): mixed;
  cache: {|[string]: ParcelModule|};
  hotData: mixed;
  Module: any;
  parent: ?ParcelRequire;
  isParcelRequire: true;
  modules: {|[string]: [Function, {|[string]: string|}]|};
  HMR_BUNDLE_ID: string;
  root: ParcelRequire;
}
interface ParcelModule {
  hot: {|
    data: mixed,
    accept(cb: (Function) => void): void,
    dispose(cb: (mixed) => void): void,
    // accept(deps: Array<string> | string, cb: (Function) => void): void,
    // decline(): void,
    _acceptCallbacks: Array<(Function) => void>,
    _disposeCallbacks: Array<(mixed) => void>,
  |};
}
declare var module: {bundle: ParcelRequire, ...};
declare var HMR_HOST: string;
declare var HMR_PORT: string;
declare var HMR_ENV_HASH: string;
declare var HMR_SECURE: boolean;
*/ var OVERLAY_ID = '__parcel__error__overlay__';
var OldModule = module.bundle.Module;
function Module(moduleName) {
    OldModule.call(this, moduleName);
    this.hot = {
        data: module.bundle.hotData,
        _acceptCallbacks: [],
        _disposeCallbacks: [],
        accept: function accept(fn) {
            this._acceptCallbacks.push(fn || function() {
            });
        },
        dispose: function dispose(fn) {
            this._disposeCallbacks.push(fn);
        }
    };
    module.bundle.hotData = undefined;
}
module.bundle.Module = Module;
var checkedAssets, acceptedAssets, assetsToAccept;
function getHostname() {
    return HMR_HOST || (location.protocol.indexOf('http') === 0 ? location.hostname : 'localhost');
}
function getPort() {
    return HMR_PORT || location.port;
} // eslint-disable-next-line no-redeclare
var parent = module.bundle.parent;
if ((!parent || !parent.isParcelRequire) && typeof WebSocket !== 'undefined') {
    var hostname = getHostname();
    var port = getPort();
    var protocol = HMR_SECURE || location.protocol == 'https:' && !/localhost|127.0.0.1|0.0.0.0/.test(hostname) ? 'wss' : 'ws';
    var ws = new WebSocket(protocol + '://' + hostname + (port ? ':' + port : '') + '/'); // $FlowFixMe
    ws.onmessage = function(event) {
        checkedAssets = {
        };
        acceptedAssets = {
        };
        assetsToAccept = [];
        var data = JSON.parse(event.data);
        if (data.type === 'update') {
            // Remove error overlay if there is one
            if (typeof document !== 'undefined') removeErrorOverlay();
            var assets = data.assets.filter(function(asset) {
                return asset.envHash === HMR_ENV_HASH;
            }); // Handle HMR Update
            var handled = assets.every(function(asset) {
                return asset.type === 'css' || asset.type === 'js' && hmrAcceptCheck(module.bundle.root, asset.id, asset.depsByBundle);
            });
            if (handled) {
                console.clear();
                assets.forEach(function(asset) {
                    hmrApply(module.bundle.root, asset);
                });
                for(var i = 0; i < assetsToAccept.length; i++){
                    var id = assetsToAccept[i][1];
                    if (!acceptedAssets[id]) hmrAcceptRun(assetsToAccept[i][0], id);
                }
            } else window.location.reload();
        }
        if (data.type === 'error') {
            // Log parcel errors to console
            var _iterator = _createForOfIteratorHelper(data.diagnostics.ansi), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var ansiDiagnostic = _step.value;
                    var stack = ansiDiagnostic.codeframe ? ansiDiagnostic.codeframe : ansiDiagnostic.stack;
                    console.error('🚨 [parcel]: ' + ansiDiagnostic.message + '\n' + stack + '\n\n' + ansiDiagnostic.hints.join('\n'));
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            if (typeof document !== 'undefined') {
                // Render the fancy html overlay
                removeErrorOverlay();
                var overlay = createErrorOverlay(data.diagnostics.html); // $FlowFixMe
                document.body.appendChild(overlay);
            }
        }
    };
    ws.onerror = function(e) {
        console.error(e.message);
    };
    ws.onclose = function() {
        console.warn('[parcel] 🚨 Connection to the HMR server was lost');
    };
}
function removeErrorOverlay() {
    var overlay = document.getElementById(OVERLAY_ID);
    if (overlay) {
        overlay.remove();
        console.log('[parcel] ✨ Error resolved');
    }
}
function createErrorOverlay(diagnostics) {
    var overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    var errorHTML = '<div style="background: black; opacity: 0.85; font-size: 16px; color: white; position: fixed; height: 100%; width: 100%; top: 0px; left: 0px; padding: 30px; font-family: Menlo, Consolas, monospace; z-index: 9999;">';
    var _iterator2 = _createForOfIteratorHelper(diagnostics), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var diagnostic = _step2.value;
            var stack = diagnostic.codeframe ? diagnostic.codeframe : diagnostic.stack;
            errorHTML += "\n      <div>\n        <div style=\"font-size: 18px; font-weight: bold; margin-top: 20px;\">\n          \uD83D\uDEA8 ".concat(diagnostic.message, "\n        </div>\n        <pre>").concat(stack, "</pre>\n        <div>\n          ").concat(diagnostic.hints.map(function(hint) {
                return '<div>💡 ' + hint + '</div>';
            }).join(''), "\n        </div>\n        ").concat(diagnostic.documentation ? "<div>\uD83D\uDCDD <a style=\"color: violet\" href=\"".concat(diagnostic.documentation, "\" target=\"_blank\">Learn more</a></div>") : '', "\n      </div>\n    ");
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    errorHTML += '</div>';
    overlay.innerHTML = errorHTML;
    return overlay;
}
function getParents(bundle, id) /*: Array<[ParcelRequire, string]> */ {
    var modules = bundle.modules;
    if (!modules) return [];
    var parents = [];
    var k, d, dep;
    for(k in modules)for(d in modules[k][1]){
        dep = modules[k][1][d];
        if (dep === id || Array.isArray(dep) && dep[dep.length - 1] === id) parents.push([
            bundle,
            k
        ]);
    }
    if (bundle.parent) parents = parents.concat(getParents(bundle.parent, id));
    return parents;
}
function updateLink(link) {
    var newLink = link.cloneNode();
    newLink.onload = function() {
        if (link.parentNode !== null) // $FlowFixMe
        link.parentNode.removeChild(link);
    };
    newLink.setAttribute('href', link.getAttribute('href').split('?')[0] + '?' + Date.now()); // $FlowFixMe
    link.parentNode.insertBefore(newLink, link.nextSibling);
}
var cssTimeout = null;
function reloadCSS() {
    if (cssTimeout) return;
    cssTimeout = setTimeout(function() {
        var links = document.querySelectorAll('link[rel="stylesheet"]');
        for(var i = 0; i < links.length; i++){
            // $FlowFixMe[incompatible-type]
            var href = links[i].getAttribute('href');
            var hostname = getHostname();
            var servedFromHMRServer = hostname === 'localhost' ? new RegExp('^(https?:\\/\\/(0.0.0.0|127.0.0.1)|localhost):' + getPort()).test(href) : href.indexOf(hostname + ':' + getPort());
            var absolute = /^https?:\/\//i.test(href) && href.indexOf(window.location.origin) !== 0 && !servedFromHMRServer;
            if (!absolute) updateLink(links[i]);
        }
        cssTimeout = null;
    }, 50);
}
function hmrApply(bundle, asset) {
    var modules = bundle.modules;
    if (!modules) return;
    if (asset.type === 'css') reloadCSS();
    else if (asset.type === 'js') {
        var deps = asset.depsByBundle[bundle.HMR_BUNDLE_ID];
        if (deps) {
            var fn = new Function('require', 'module', 'exports', asset.output);
            modules[asset.id] = [
                fn,
                deps
            ];
        } else if (bundle.parent) hmrApply(bundle.parent, asset);
    }
}
function hmrAcceptCheck(bundle, id, depsByBundle) {
    var modules = bundle.modules;
    if (!modules) return;
    if (depsByBundle && !depsByBundle[bundle.HMR_BUNDLE_ID]) {
        // If we reached the root bundle without finding where the asset should go,
        // there's nothing to do. Mark as "accepted" so we don't reload the page.
        if (!bundle.parent) return true;
        return hmrAcceptCheck(bundle.parent, id, depsByBundle);
    }
    if (checkedAssets[id]) return true;
    checkedAssets[id] = true;
    var cached = bundle.cache[id];
    assetsToAccept.push([
        bundle,
        id
    ]);
    if (cached && cached.hot && cached.hot._acceptCallbacks.length) return true;
    var parents = getParents(module.bundle.root, id); // If no parents, the asset is new. Prevent reloading the page.
    if (!parents.length) return true;
    return parents.some(function(v) {
        return hmrAcceptCheck(v[0], v[1], null);
    });
}
function hmrAcceptRun(bundle, id) {
    var cached = bundle.cache[id];
    bundle.hotData = {
    };
    if (cached && cached.hot) cached.hot.data = bundle.hotData;
    if (cached && cached.hot && cached.hot._disposeCallbacks.length) cached.hot._disposeCallbacks.forEach(function(cb) {
        cb(bundle.hotData);
    });
    delete bundle.cache[id];
    bundle(id);
    cached = bundle.cache[id];
    if (cached && cached.hot && cached.hot._acceptCallbacks.length) cached.hot._acceptCallbacks.forEach(function(cb) {
        var assetsToAlsoAccept = cb(function() {
            return getParents(module.bundle.root, id);
        });
        if (assetsToAlsoAccept && assetsToAccept.length) // $FlowFixMe[method-unbinding]
        assetsToAccept.push.apply(assetsToAccept, assetsToAlsoAccept);
    });
    acceptedAssets[id] = true;
}

},{}],"dA00B":[function(require,module,exports) {
"use strict";
require('../scss/theme.scss');
require('unfetch/polyfill');
require('es6-promise/auto');
var _require = require('@shopify/theme-sections'), load = _require.load; // Require lazysizes
require('lazysizes');
require('lazysizes/plugins/respimg/ls.respimg'); // Require components
require('./components/utilities');
require('./components/ajax-cart');
require('./components/free-gift');
require('./components/header-search');
require('./components/image');
require('./components/jump-menu');
require('./components/lightbox');
require('./components/nav');
require('./components/nav-primary');
require('./components/order-deadline');
require('./components/predictive-search');
require('./components/shipping-protection');
require('./components/slideshow'); // Require sections
require('./sections/footer');
require('./sections/product-template');
require('./sections/sidebar');
require('./sections/slideshow');
require('./sections/video'); // Require templates
require('./templates/addresses');
require('./templates/login'); // Load sections
load('*');

},{"../scss/theme.scss":"ayr00","unfetch/polyfill":"ar9fw","es6-promise/auto":"kLw2j","@shopify/theme-sections":"9w7jG","lazysizes":"cW810","lazysizes/plugins/respimg/ls.respimg":"4TU5q","./components/utilities":"8r8MO","./components/ajax-cart":"ggxmq","./components/free-gift":"eBK23","./components/header-search":"4P1lh","./components/image":"j41Og","./components/jump-menu":"cG7Js","./components/lightbox":"fI3HX","./components/nav":"47p9h","./components/nav-primary":"2gSkO","./components/order-deadline":"gK8W9","./components/predictive-search":"l4zyu","./components/shipping-protection":"bLBRl","./components/slideshow":"gJwdl","./sections/footer":"13O24","./sections/product-template":"7gkUE","./sections/sidebar":"2XJxj","./sections/slideshow":"96Uhz","./sections/video":"l5KRS","./templates/addresses":"fjiJG","./templates/login":"4FKA8"}],"ayr00":[function() {},{}],"ar9fw":[function(require,module,exports) {
self.fetch || (self.fetch = function(e, n) {
    return n = n || {
    }, new Promise(function(t, s) {
        var r = new XMLHttpRequest, o = [], u = [], i = {
        }, a = function() {
            return {
                ok: 2 == (r.status / 100 | 0),
                statusText: r.statusText,
                status: r.status,
                url: r.responseURL,
                text: function() {
                    return Promise.resolve(r.responseText);
                },
                json: function() {
                    return Promise.resolve(r.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        r.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var c in r.open(n.method || "get", e, !0), r.onload = function() {
            r.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, r.onerror = s, r.withCredentials = "include" == n.credentials, n.headers)r.setRequestHeader(c, n.headers[c]);
        r.send(n.body || null);
    });
});

},{}],"kLw2j":[function(require,module,exports) {
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');
'use strict';
module.exports = require('./').polyfill();

},{"./":"3Oz5m"}],"3Oz5m":[function(require,module,exports) {
var process = require("process");
var global = arguments[3];
(function(global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.ES6Promise = factory();
})(this, function() {
    'use strict';
    function objectOrFunction(x) {
        var type = typeof x;
        return x !== null && (type === 'object' || type === 'function');
    }
    function isFunction(x) {
        return typeof x === 'function';
    }
    var _isArray = void 0;
    if (Array.isArray) _isArray = Array.isArray;
    else _isArray = function(x) {
        return Object.prototype.toString.call(x) === '[object Array]';
    };
    var isArray = _isArray;
    var len = 0;
    var vertxNext = void 0;
    var customSchedulerFn = void 0;
    var asap = function asap(callback, arg) {
        queue[len] = callback;
        queue[len + 1] = arg;
        len += 2;
        if (len === 2) {
            // If len is 2, that means that we need to schedule an async flush.
            // If additional callbacks are queued before the queue is flushed, they
            // will be processed by this flush that we are scheduling.
            if (customSchedulerFn) customSchedulerFn(flush);
            else scheduleFlush();
        }
    };
    function setScheduler(scheduleFn) {
        customSchedulerFn = scheduleFn;
    }
    function setAsap(asapFn) {
        asap = asapFn;
    }
    var browserWindow = typeof window !== 'undefined' ? window : undefined;
    var browserGlobal = browserWindow || {
    };
    var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
    var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({
    }).toString.call(process) === '[object process]';
    // test for web worker but not in IE10
    var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
    // node
    function useNextTick() {
        // node version 0.10.x displays a deprecation warning when nextTick is used recursively
        // see https://github.com/cujojs/when/issues/410 for details
        return function() {
            return process.nextTick(flush);
        };
    }
    // vertx
    function useVertxTimer() {
        if (typeof vertxNext !== 'undefined') return function() {
            vertxNext(flush);
        };
        return useSetTimeout();
    }
    function useMutationObserver() {
        var iterations = 0;
        var observer = new BrowserMutationObserver(flush);
        var node = document.createTextNode('');
        observer.observe(node, {
            characterData: true
        });
        return function() {
            node.data = iterations = ++iterations % 2;
        };
    }
    // web worker
    function useMessageChannel() {
        var channel = new MessageChannel();
        channel.port1.onmessage = flush;
        return function() {
            return channel.port2.postMessage(0);
        };
    }
    function useSetTimeout() {
        // Store setTimeout reference so es6-promise will be unaffected by
        // other code modifying setTimeout (like sinon.useFakeTimers())
        var globalSetTimeout = setTimeout;
        return function() {
            return globalSetTimeout(flush, 1);
        };
    }
    var queue = new Array(1000);
    function flush() {
        for(var i = 0; i < len; i += 2){
            var callback = queue[i];
            var arg = queue[i + 1];
            callback(arg);
            queue[i] = undefined;
            queue[i + 1] = undefined;
        }
        len = 0;
    }
    function attemptVertx() {
        try {
            var vertx = Function('return this')().require('vertx');
            vertxNext = vertx.runOnLoop || vertx.runOnContext;
            return useVertxTimer();
        } catch (e) {
            return useSetTimeout();
        }
    }
    var scheduleFlush = void 0;
    // Decide what async method to use to triggering processing of queued callbacks:
    if (isNode) scheduleFlush = useNextTick();
    else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
    else if (isWorker) scheduleFlush = useMessageChannel();
    else if (browserWindow === undefined && typeof require === 'function') scheduleFlush = attemptVertx();
    else scheduleFlush = useSetTimeout();
    function then(onFulfillment, onRejection) {
        var parent = this;
        var child = new this.constructor(noop);
        if (child[PROMISE_ID] === undefined) makePromise(child);
        var _state = parent._state;
        if (_state) {
            var callback = arguments[_state - 1];
            asap(function() {
                return invokeCallback(_state, child, callback, parent._result);
            });
        } else subscribe(parent, child, onFulfillment, onRejection);
        return child;
    }
    /**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object) {
        /*jshint validthis:true */ var Constructor = this;
        if (object && typeof object === 'object' && object.constructor === Constructor) return object;
        var promise = new Constructor(noop);
        resolve(promise, object);
        return promise;
    }
    var PROMISE_ID = Math.random().toString(36).substring(2);
    function noop() {
    }
    var PENDING = void 0;
    var FULFILLED = 1;
    var REJECTED = 2;
    function selfFulfillment() {
        return new TypeError("You cannot resolve a promise with itself");
    }
    function cannotReturnOwn() {
        return new TypeError('A promises callback cannot return that same promise.');
    }
    function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
        try {
            then$$1.call(value, fulfillmentHandler, rejectionHandler);
        } catch (e) {
            return e;
        }
    }
    function handleForeignThenable(promise, thenable, then$$1) {
        asap(function(promise) {
            var sealed = false;
            var error = tryThen(then$$1, thenable, function(value) {
                if (sealed) return;
                sealed = true;
                if (thenable !== value) resolve(promise, value);
                else fulfill(promise, value);
            }, function(reason) {
                if (sealed) return;
                sealed = true;
                reject(promise, reason);
            }, 'Settle: ' + (promise._label || ' unknown promise'));
            if (!sealed && error) {
                sealed = true;
                reject(promise, error);
            }
        }, promise);
    }
    function handleOwnThenable(promise, thenable) {
        if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
        else if (thenable._state === REJECTED) reject(promise, thenable._result);
        else subscribe(thenable, undefined, function(value) {
            return resolve(promise, value);
        }, function(reason) {
            return reject(promise, reason);
        });
    }
    function handleMaybeThenable(promise, maybeThenable, then$$1) {
        if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
        else {
            if (then$$1 === undefined) fulfill(promise, maybeThenable);
            else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
            else fulfill(promise, maybeThenable);
        }
    }
    function resolve(promise, value) {
        if (promise === value) reject(promise, selfFulfillment());
        else if (objectOrFunction(value)) {
            var then$$1 = void 0;
            try {
                then$$1 = value.then;
            } catch (error) {
                reject(promise, error);
                return;
            }
            handleMaybeThenable(promise, value, then$$1);
        } else fulfill(promise, value);
    }
    function publishRejection(promise) {
        if (promise._onerror) promise._onerror(promise._result);
        publish(promise);
    }
    function fulfill(promise, value) {
        if (promise._state !== PENDING) return;
        promise._result = value;
        promise._state = FULFILLED;
        if (promise._subscribers.length !== 0) asap(publish, promise);
    }
    function reject(promise, reason) {
        if (promise._state !== PENDING) return;
        promise._state = REJECTED;
        promise._result = reason;
        asap(publishRejection, promise);
    }
    function subscribe(parent, child, onFulfillment, onRejection) {
        var _subscribers = parent._subscribers;
        var length = _subscribers.length;
        parent._onerror = null;
        _subscribers[length] = child;
        _subscribers[length + FULFILLED] = onFulfillment;
        _subscribers[length + REJECTED] = onRejection;
        if (length === 0 && parent._state) asap(publish, parent);
    }
    function publish(promise) {
        var subscribers = promise._subscribers;
        var settled = promise._state;
        if (subscribers.length === 0) return;
        var child = void 0, callback = void 0, detail = promise._result;
        for(var i = 0; i < subscribers.length; i += 3){
            child = subscribers[i];
            callback = subscribers[i + settled];
            if (child) invokeCallback(settled, child, callback, detail);
            else callback(detail);
        }
        promise._subscribers.length = 0;
    }
    function invokeCallback(settled, promise, callback, detail) {
        var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = true;
        if (hasCallback) {
            try {
                value = callback(detail);
            } catch (e) {
                succeeded = false;
                error = e;
            }
            if (promise === value) {
                reject(promise, cannotReturnOwn());
                return;
            }
        } else value = detail;
        if (promise._state !== PENDING) ;
        else if (hasCallback && succeeded) resolve(promise, value);
        else if (succeeded === false) reject(promise, error);
        else if (settled === FULFILLED) fulfill(promise, value);
        else if (settled === REJECTED) reject(promise, value);
    }
    function initializePromise(promise, resolver) {
        try {
            resolver(function resolvePromise(value) {
                resolve(promise, value);
            }, function rejectPromise(reason) {
                reject(promise, reason);
            });
        } catch (e) {
            reject(promise, e);
        }
    }
    var id = 0;
    function nextId() {
        return id++;
    }
    function makePromise(promise) {
        promise[PROMISE_ID] = id++;
        promise._state = undefined;
        promise._result = undefined;
        promise._subscribers = [];
    }
    function validationError() {
        return new Error('Array Methods must be provided an Array');
    }
    var Enumerator = function() {
        function Enumerator(Constructor, input) {
            this._instanceConstructor = Constructor;
            this.promise = new Constructor(noop);
            if (!this.promise[PROMISE_ID]) makePromise(this.promise);
            if (isArray(input)) {
                this.length = input.length;
                this._remaining = input.length;
                this._result = new Array(this.length);
                if (this.length === 0) fulfill(this.promise, this._result);
                else {
                    this.length = this.length || 0;
                    this._enumerate(input);
                    if (this._remaining === 0) fulfill(this.promise, this._result);
                }
            } else reject(this.promise, validationError());
        }
        Enumerator.prototype._enumerate = function _enumerate(input) {
            for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
        };
        Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
            var c = this._instanceConstructor;
            var resolve$$1 = c.resolve;
            if (resolve$$1 === resolve$1) {
                var _then = void 0;
                var error = void 0;
                var didError = false;
                try {
                    _then = entry.then;
                } catch (e) {
                    didError = true;
                    error = e;
                }
                if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                else if (typeof _then !== 'function') {
                    this._remaining--;
                    this._result[i] = entry;
                } else if (c === Promise$1) {
                    var promise = new c(noop);
                    if (didError) reject(promise, error);
                    else handleMaybeThenable(promise, entry, _then);
                    this._willSettleAt(promise, i);
                } else this._willSettleAt(new c(function(resolve$$1) {
                    return resolve$$1(entry);
                }), i);
            } else this._willSettleAt(resolve$$1(entry), i);
        };
        Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
            var promise = this.promise;
            if (promise._state === PENDING) {
                this._remaining--;
                if (state === REJECTED) reject(promise, value);
                else this._result[i] = value;
            }
            if (this._remaining === 0) fulfill(promise, this._result);
        };
        Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
            var enumerator = this;
            subscribe(promise, undefined, function(value) {
                return enumerator._settledAt(FULFILLED, i, value);
            }, function(reason) {
                return enumerator._settledAt(REJECTED, i, reason);
            });
        };
        return Enumerator;
    }();
    /**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries) {
        return new Enumerator(this, entries).promise;
    }
    /**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries) {
        /*jshint validthis:true */ var Constructor = this;
        if (!isArray(entries)) return new Constructor(function(_, reject) {
            return reject(new TypeError('You must pass an array to race.'));
        });
        else return new Constructor(function(resolve, reject) {
            var length = entries.length;
            for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve, reject);
        });
    }
    /**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason) {
        /*jshint validthis:true */ var Constructor = this;
        var promise = new Constructor(noop);
        reject(promise, reason);
        return promise;
    }
    function needsResolver() {
        throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
    }
    function needsNew() {
        throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }
    /**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/ var Promise$1 = function() {
        function Promise(resolver) {
            this[PROMISE_ID] = nextId();
            this._result = this._state = undefined;
            this._subscribers = [];
            if (noop !== resolver) {
                typeof resolver !== 'function' && needsResolver();
                this instanceof Promise ? initializePromise(this, resolver) : needsNew();
            }
        }
        /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */ /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection) {
            return this.then(null, onRejection);
        };
        /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback) {
            var promise = this;
            var constructor = promise.constructor;
            if (isFunction(callback)) return promise.then(function(value) {
                return constructor.resolve(callback()).then(function() {
                    return value;
                });
            }, function(reason) {
                return constructor.resolve(callback()).then(function() {
                    throw reason;
                });
            });
            return promise.then(callback, callback);
        };
        return Promise;
    }();
    Promise$1.prototype.then = then;
    Promise$1.all = all;
    Promise$1.race = race;
    Promise$1.resolve = resolve$1;
    Promise$1.reject = reject$1;
    Promise$1._setScheduler = setScheduler;
    Promise$1._setAsap = setAsap;
    Promise$1._asap = asap;
    /*global self*/ function polyfill() {
        var local = void 0;
        if (typeof global !== 'undefined') local = global;
        else if (typeof self !== 'undefined') local = self;
        else try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
        var P = local.Promise;
        if (P) {
            var promiseToString = null;
            try {
                promiseToString = Object.prototype.toString.call(P.resolve());
            } catch (e) {
            // silently ignored
            }
            if (promiseToString === '[object Promise]' && !P.cast) return;
        }
        local.Promise = Promise$1;
    }
    // Strange compat..
    Promise$1.polyfill = polyfill;
    Promise$1.Promise = Promise$1;
    return Promise$1;
});

},{"process":"djbKH"}],"djbKH":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {
};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e1) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {
};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {
};
function noop() {
}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"9w7jG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registered", ()=>registered
);
parcelHelpers.export(exports, "instances", ()=>instances
);
parcelHelpers.export(exports, "register", ()=>register
);
parcelHelpers.export(exports, "unregister", ()=>unregister
);
parcelHelpers.export(exports, "load", ()=>load
);
parcelHelpers.export(exports, "unload", ()=>unload
);
parcelHelpers.export(exports, "extend", ()=>extend
);
parcelHelpers.export(exports, "getInstances", ()=>getInstances
);
parcelHelpers.export(exports, "getInstanceById", ()=>getInstanceById
);
parcelHelpers.export(exports, "isInstance", ()=>isInstance
);
/*
 * @shopify/theme-sections
 * -----------------------------------------------------------------------------
 *
 * A framework to provide structure to your Shopify sections and a load and unload
 * lifecycle. The lifecycle is automatically connected to theme editor events so
 * that your sections load and unload as the editor changes the content and
 * settings of your sections.
 */ var _section = require("./section");
var _sectionDefault = parcelHelpers.interopDefault(_section);
var SECTION_TYPE_ATTR = 'data-section-type';
var SECTION_ID_ATTR = 'data-section-id';
window.Shopify = window.Shopify || {
};
window.Shopify.theme = window.Shopify.theme || {
};
window.Shopify.theme.sections = window.Shopify.theme.sections || {
};
var registered = window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {
};
var instances = window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
function register(type, properties) {
    if (typeof type !== 'string') throw new TypeError('Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered');
    if (typeof registered[type] !== 'undefined') throw new Error('Theme Sections: A section of type "' + type + '" has already been registered. You cannot register the same section type twice');
    function TypedSection(container) {
        _sectionDefault.default.call(this, container, properties);
    }
    TypedSection.constructor = _sectionDefault.default;
    TypedSection.prototype = Object.create(_sectionDefault.default.prototype);
    TypedSection.prototype.type = type;
    return registered[type] = TypedSection;
}
function unregister(types) {
    types = normalizeType(types);
    types.forEach(function(type) {
        delete registered[type];
    });
}
function load(types, containers) {
    types = normalizeType(types);
    if (typeof containers === 'undefined') containers = document.querySelectorAll('[' + SECTION_TYPE_ATTR + ']');
    containers = normalizeContainers(containers);
    types.forEach(function(type) {
        var TypedSection = registered[type];
        if (typeof TypedSection === 'undefined') return;
        containers = containers.filter(function(container) {
            // Filter from list of containers because container already has an instance loaded
            if (isInstance(container)) return false;
            // Filter from list of containers because container doesn't have data-section-type attribute
            if (container.getAttribute(SECTION_TYPE_ATTR) === null) return false;
            // Keep in list of containers because current type doesn't match
            if (container.getAttribute(SECTION_TYPE_ATTR) !== type) return true;
            instances.push(new TypedSection(container));
            // Filter from list of containers because container now has an instance loaded
            return false;
        });
    });
}
function unload(selector) {
    var instancesToUnload = getInstances(selector);
    instancesToUnload.forEach(function(instance) {
        var index = instances.map(function(e) {
            return e.id;
        }).indexOf(instance.id);
        instances.splice(index, 1);
        instance.onUnload();
    });
}
function extend(selector, extension) {
    var instancesToExtend = getInstances(selector);
    instancesToExtend.forEach(function(instance) {
        instance.extend(extension);
    });
}
function getInstances(selector) {
    var filteredInstances = [];
    // Fetch first element if its an array
    if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) var firstElement = selector[0];
    // If selector element is DOM element
    if (selector instanceof Element || firstElement instanceof Element) {
        var containers = normalizeContainers(selector);
        containers.forEach(function(container) {
            filteredInstances = filteredInstances.concat(instances.filter(function(instance) {
                return instance.container === container;
            }));
        });
    // If select is type string
    } else if (typeof selector === 'string' || typeof firstElement === 'string') {
        var types = normalizeType(selector);
        types.forEach(function(type) {
            filteredInstances = filteredInstances.concat(instances.filter(function(instance) {
                return instance.type === type;
            }));
        });
    }
    return filteredInstances;
}
function getInstanceById(id) {
    var instance;
    for(var i = 0; i < instances.length; i++)if (instances[i].id === id) {
        instance = instances[i];
        break;
    }
    return instance;
}
function isInstance(selector) {
    return getInstances(selector).length > 0;
}
function normalizeType(types) {
    // If '*' then fetch all registered section types
    if (types === '*') types = Object.keys(registered);
    else if (typeof types === 'string') types = [
        types
    ];
    else if (types.constructor === _sectionDefault.default) types = [
        types.prototype.type
    ];
    else if (Array.isArray(types) && types[0].constructor === _sectionDefault.default) types = types.map(function(TypedSection) {
        return TypedSection.prototype.type;
    });
    types = types.map(function(type) {
        return type.toLowerCase();
    });
    return types;
}
function normalizeContainers(containers) {
    // Nodelist with entries
    if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) containers = Array.prototype.slice.call(containers);
    else if (NodeList.prototype.isPrototypeOf(containers) && containers.length === 0) containers = [];
    else if (containers === null) containers = [];
    else if (!Array.isArray(containers) && containers instanceof Element) containers = [
        containers
    ];
    return containers;
}
if (window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
        var id = event.detail.sectionId;
        var container = event.target.querySelector('[' + SECTION_ID_ATTR + '="' + id + '"]');
        if (container !== null) load(container.getAttribute(SECTION_TYPE_ATTR), container);
    });
    document.addEventListener('shopify:section:unload', function(event) {
        var id = event.detail.sectionId;
        var container = event.target.querySelector('[' + SECTION_ID_ATTR + '="' + id + '"]');
        var instance = getInstances(container)[0];
        if (typeof instance === 'object') unload(container);
    });
    document.addEventListener('shopify:section:select', function(event) {
        var instance = getInstanceById(event.detail.sectionId);
        if (typeof instance === 'object') instance.onSelect(event);
    });
    document.addEventListener('shopify:section:deselect', function(event) {
        var instance = getInstanceById(event.detail.sectionId);
        if (typeof instance === 'object') instance.onDeselect(event);
    });
    document.addEventListener('shopify:block:select', function(event) {
        var instance = getInstanceById(event.detail.sectionId);
        if (typeof instance === 'object') instance.onBlockSelect(event);
    });
    document.addEventListener('shopify:block:deselect', function(event) {
        var instance = getInstanceById(event.detail.sectionId);
        if (typeof instance === 'object') instance.onBlockDeselect(event);
    });
}

},{"./section":"8TE5u","@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"8TE5u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var SECTION_ID_ATTR = 'data-section-id';
function Section(container, properties) {
    this.container = validateContainerElement(container);
    this.id = container.getAttribute(SECTION_ID_ATTR);
    this.extensions = [];
    // eslint-disable-next-line es5/no-es6-static-methods
    Object.assign(this, validatePropertiesObject(properties));
    this.onLoad();
}
exports.default = Section;
Section.prototype = {
    onLoad: Function.prototype,
    onUnload: Function.prototype,
    onSelect: Function.prototype,
    onDeselect: Function.prototype,
    onBlockSelect: Function.prototype,
    onBlockDeselect: Function.prototype,
    extend: function extend(extension) {
        this.extensions.push(extension); // Save original extension
        // eslint-disable-next-line es5/no-es6-static-methods
        var extensionClone = Object.assign({
        }, extension);
        delete extensionClone.init; // Remove init function before assigning extension properties
        // eslint-disable-next-line es5/no-es6-static-methods
        Object.assign(this, extensionClone);
        if (typeof extension.init === 'function') extension.init.apply(this);
    }
};
function validateContainerElement(container) {
    if (!(container instanceof Element)) throw new TypeError('Theme Sections: Attempted to load section. The section container provided is not a DOM element.');
    if (container.getAttribute(SECTION_ID_ATTR) === null) throw new Error('Theme Sections: The section container provided does not have an id assigned to the ' + SECTION_ID_ATTR + ' attribute.');
    return container;
}
function validatePropertiesObject(value) {
    if (typeof value !== 'undefined' && typeof value !== 'object' || value === null) throw new TypeError('Theme Sections: The properties object provided is not a valid');
    return value;
}
// Object.assign() polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
if (typeof Object.assign != 'function') // Must be writable: true, enumerable: false, configurable: true
Object.defineProperty(Object, 'assign', {
    value: function assign(target) {
        if (target == null) // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
        var to = Object(target);
        for(var index = 1; index < arguments.length; index++){
            var nextSource = arguments[index];
            if (nextSource != null) {
                // Skip over if undefined or null
                for(var nextKey in nextSource)// Avoid bugs when hasOwnProperty is shadowed
                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) to[nextKey] = nextSource[nextKey];
            }
        }
        return to;
    },
    writable: true,
    configurable: true
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"8FsVl":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"cW810":[function(require,module,exports) {
(function(window, factory) {
    var lazySizes = factory(window, window.document, Date);
    window.lazySizes = lazySizes;
    if (typeof module == 'object' && module.exports) module.exports = lazySizes;
})(typeof window != 'undefined' ? window : {
}, /**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */ function l(window, document, Date) {
    'use strict';
    /*jshint eqnull:true */ var lazysizes, /**
		 * @type { LazySizesConfigPartial }
		 */ lazySizesCfg;
    (function() {
        var prop;
        var lazySizesDefaults = {
            lazyClass: 'lazyload',
            loadedClass: 'lazyloaded',
            loadingClass: 'lazyloading',
            preloadClass: 'lazypreload',
            errorClass: 'lazyerror',
            //strictClass: 'lazystrict',
            autosizesClass: 'lazyautosizes',
            fastLoadedClass: 'ls-is-cached',
            iframeLoadMode: 0,
            srcAttr: 'data-src',
            srcsetAttr: 'data-srcset',
            sizesAttr: 'data-sizes',
            //preloadAfterLoad: false,
            minSize: 40,
            customMedia: {
            },
            init: true,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: true,
            ricTimeout: 0,
            throttleDelay: 125
        };
        lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {
        };
        for(prop in lazySizesDefaults)if (!(prop in lazySizesCfg)) lazySizesCfg[prop] = lazySizesDefaults[prop];
    })();
    if (!document || !document.getElementsByClassName) return {
        init: function() {
        },
        /**
			 * @type { LazySizesConfigPartial }
			 */ cfg: lazySizesCfg,
        /**
			 * @type { true }
			 */ noSupport: true
    };
    var docElem = document.documentElement;
    var supportPicture = window.HTMLPictureElement;
    var _addEventListener = 'addEventListener';
    var _getAttribute = 'getAttribute';
    /**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */ var addEventListener = window[_addEventListener].bind(window);
    var setTimeout = window.setTimeout;
    var requestAnimationFrame = window.requestAnimationFrame || setTimeout;
    var requestIdleCallback = window.requestIdleCallback;
    var regPicture = /^picture$/i;
    var loadEvents = [
        'load',
        'error',
        'lazyincluded',
        '_lazyloaded'
    ];
    var regClassCache = {
    };
    var forEach = Array.prototype.forEach;
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var hasClass = function(ele, cls) {
        if (!regClassCache[cls]) regClassCache[cls] = new RegExp('(\\s|^)' + cls + '(\\s|$)');
        return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var addClass = function(ele, cls) {
        if (!hasClass(ele, cls)) ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var removeClass = function(ele, cls) {
        var reg;
        if (reg = hasClass(ele, cls)) ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
    };
    var addRemoveLoadEvents = function(dom, fn, add) {
        var action = add ? _addEventListener : 'removeEventListener';
        if (add) addRemoveLoadEvents(dom, fn);
        loadEvents.forEach(function(evt) {
            dom[action](evt, fn);
        });
    };
    /**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */ var triggerEvent = function(elem, name, detail, noBubbles, noCancelable) {
        var event = document.createEvent('Event');
        if (!detail) detail = {
        };
        detail.instance = lazysizes;
        event.initEvent(name, !noBubbles, !noCancelable);
        event.detail = detail;
        elem.dispatchEvent(event);
        return event;
    };
    var updatePolyfill = function(el, full) {
        var polyfill;
        if (!supportPicture && (polyfill = window.picturefill || lazySizesCfg.pf)) {
            if (full && full.src && !el[_getAttribute]('srcset')) el.setAttribute('srcset', full.src);
            polyfill({
                reevaluate: true,
                elements: [
                    el
                ]
            });
        } else if (full && full.src) el.src = full.src;
    };
    var getCSS = function(elem, style) {
        return (getComputedStyle(elem, null) || {
        })[style];
    };
    /**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */ var getWidth = function(elem, parent, width) {
        width = width || elem.offsetWidth;
        while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
            width = parent.offsetWidth;
            parent = parent.parentNode;
        }
        return width;
    };
    var rAF = function() {
        var running, waiting;
        var firstFns = [];
        var secondFns = [];
        var fns = firstFns;
        var run = function() {
            var runFns = fns;
            fns = firstFns.length ? secondFns : firstFns;
            running = true;
            waiting = false;
            while(runFns.length)runFns.shift()();
            running = false;
        };
        var rafBatch = function(fn, queue) {
            if (running && !queue) fn.apply(this, arguments);
            else {
                fns.push(fn);
                if (!waiting) {
                    waiting = true;
                    (document.hidden ? setTimeout : requestAnimationFrame)(run);
                }
            }
        };
        rafBatch._lsFlush = run;
        return rafBatch;
    }();
    var rAFIt = function(fn, simple) {
        return simple ? function() {
            rAF(fn);
        } : function() {
            var that = this;
            var args = arguments;
            rAF(function() {
                fn.apply(that, args);
            });
        };
    };
    var throttle = function(fn) {
        var running;
        var lastTime = 0;
        var gDelay = lazySizesCfg.throttleDelay;
        var rICTimeout = lazySizesCfg.ricTimeout;
        var run = function() {
            running = false;
            lastTime = Date.now();
            fn();
        };
        var idleCallback = requestIdleCallback && rICTimeout > 49 ? function() {
            requestIdleCallback(run, {
                timeout: rICTimeout
            });
            if (rICTimeout !== lazySizesCfg.ricTimeout) rICTimeout = lazySizesCfg.ricTimeout;
        } : rAFIt(function() {
            setTimeout(run);
        }, true);
        return function(isPriority) {
            var delay;
            if (isPriority = isPriority === true) rICTimeout = 33;
            if (running) return;
            running = true;
            delay = gDelay - (Date.now() - lastTime);
            if (delay < 0) delay = 0;
            if (isPriority || delay < 9) idleCallback();
            else setTimeout(idleCallback, delay);
        };
    };
    //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
    var debounce = function(func) {
        var timeout, timestamp;
        var wait = 99;
        var run = function() {
            timeout = null;
            func();
        };
        var later = function() {
            var last = Date.now() - timestamp;
            if (last < wait) setTimeout(later, wait - last);
            else (requestIdleCallback || run)(run);
        };
        return function() {
            timestamp = Date.now();
            if (!timeout) timeout = setTimeout(later, wait);
        };
    };
    var loader = function() {
        var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
        var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;
        var regImg = /^img$/i;
        var regIframe = /^iframe$/i;
        var supportScroll = 'onscroll' in window && !/(gle|ing)bot/.test(navigator.userAgent);
        var shrinkExpand = 0;
        var currentExpand = 0;
        var isLoading = 0;
        var lowRuns = -1;
        var resetPreloading = function(e) {
            isLoading--;
            if (!e || isLoading < 0 || !e.target) isLoading = 0;
        };
        var isVisible = function(elem) {
            if (isBodyHidden == null) isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
            return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
        };
        var isNestedVisible = function(elem, elemExpand) {
            var outerRect;
            var parent = elem;
            var visible = isVisible(elem);
            eLtop -= elemExpand;
            eLbottom += elemExpand;
            eLleft -= elemExpand;
            eLright += elemExpand;
            while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
                visible = (getCSS(parent, 'opacity') || 1) > 0;
                if (visible && getCSS(parent, 'overflow') != 'visible') {
                    outerRect = parent.getBoundingClientRect();
                    visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
                }
            }
            return visible;
        };
        var checkElements = function() {
            var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
            var lazyloadElems = lazysizes.elements;
            if ((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {
                i = 0;
                lowRuns++;
                for(; i < eLlen; i++){
                    if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) continue;
                    if (!supportScroll || lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i])) {
                        unveilElement(lazyloadElems[i]);
                        continue;
                    }
                    if (!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)) elemExpand = currentExpand;
                    if (!defaultExpand) {
                        defaultExpand = !lazySizesCfg.expand || lazySizesCfg.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesCfg.expand;
                        lazysizes._defEx = defaultExpand;
                        preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                        hFac = lazySizesCfg.hFac;
                        isBodyHidden = null;
                        if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
                            currentExpand = preloadExpand;
                            lowRuns = 0;
                        } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) currentExpand = defaultExpand;
                        else currentExpand = shrinkExpand;
                    }
                    if (beforeExpandVal !== elemExpand) {
                        eLvW = innerWidth + elemExpand * hFac;
                        elvH = innerHeight + elemExpand;
                        elemNegativeExpand = elemExpand * -1;
                        beforeExpandVal = elemExpand;
                    }
                    rect = lazyloadElems[i].getBoundingClientRect();
                    if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
                        unveilElement(lazyloadElems[i]);
                        loadedSomething = true;
                        if (isLoading > 9) break;
                    } else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesCfg.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto'))) autoLoadElem = preloadElems[0] || lazyloadElems[i];
                }
                if (autoLoadElem && !loadedSomething) unveilElement(autoLoadElem);
            }
        };
        var throttledCheckElements = throttle(checkElements);
        var switchLoadingClass = function(e) {
            var elem = e.target;
            if (elem._lazyCache) {
                delete elem._lazyCache;
                return;
            }
            resetPreloading(e);
            addClass(elem, lazySizesCfg.loadedClass);
            removeClass(elem, lazySizesCfg.loadingClass);
            addRemoveLoadEvents(elem, rafSwitchLoadingClass);
            triggerEvent(elem, 'lazyloaded');
        };
        var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
        var rafSwitchLoadingClass = function(e) {
            rafedSwitchLoadingClass({
                target: e.target
            });
        };
        var changeIframeSrc = function(elem, src) {
            var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;
            // loadMode can be also a string!
            if (loadMode == 0) elem.contentWindow.location.replace(src);
            else if (loadMode == 1) elem.src = src;
        };
        var handleSources = function(source) {
            var customMedia;
            var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);
            if (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) source.setAttribute('media', customMedia);
            if (sourceSrcset) source.setAttribute('srcset', sourceSrcset);
        };
        var lazyUnveil = rAFIt(function(elem, detail, isAuto, sizes, isImg) {
            var src, srcset, parent, isPicture, event, firesLoad;
            if (!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented) {
                if (sizes) {
                    if (isAuto) addClass(elem, lazySizesCfg.autosizesClass);
                    else elem.setAttribute('sizes', sizes);
                }
                srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
                src = elem[_getAttribute](lazySizesCfg.srcAttr);
                if (isImg) {
                    parent = elem.parentNode;
                    isPicture = parent && regPicture.test(parent.nodeName || '');
                }
                firesLoad = detail.firesLoad || 'src' in elem && (srcset || src || isPicture);
                event = {
                    target: elem
                };
                addClass(elem, lazySizesCfg.loadingClass);
                if (firesLoad) {
                    clearTimeout(resetPreloadingTimer);
                    resetPreloadingTimer = setTimeout(resetPreloading, 2500);
                    addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
                }
                if (isPicture) forEach.call(parent.getElementsByTagName('source'), handleSources);
                if (srcset) elem.setAttribute('srcset', srcset);
                else if (src && !isPicture) {
                    if (regIframe.test(elem.nodeName)) changeIframeSrc(elem, src);
                    else elem.src = src;
                }
                if (isImg && (srcset || isPicture)) updatePolyfill(elem, {
                    src: src
                });
            }
            if (elem._lazyRace) delete elem._lazyRace;
            removeClass(elem, lazySizesCfg.lazyClass);
            rAF(function() {
                // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
                var isLoaded = elem.complete && elem.naturalWidth > 1;
                if (!firesLoad || isLoaded) {
                    if (isLoaded) addClass(elem, lazySizesCfg.fastLoadedClass);
                    switchLoadingClass(event);
                    elem._lazyCache = true;
                    setTimeout(function() {
                        if ('_lazyCache' in elem) delete elem._lazyCache;
                    }, 9);
                }
                if (elem.loading == 'lazy') isLoading--;
            }, true);
        });
        /**
		 *
		 * @param elem { Element }
		 */ var unveilElement = function(elem) {
            if (elem._lazyRace) return;
            var detail;
            var isImg = regImg.test(elem.nodeName);
            //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
            var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
            var isAuto = sizes == 'auto';
            if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)) return;
            detail = triggerEvent(elem, 'lazyunveilread').detail;
            if (isAuto) autoSizer.updateElem(elem, true, elem.offsetWidth);
            elem._lazyRace = true;
            isLoading++;
            lazyUnveil(elem, detail, isAuto, sizes, isImg);
        };
        var afterScroll = debounce(function() {
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
        });
        var altLoadmodeScrollListner = function() {
            if (lazySizesCfg.loadMode == 3) lazySizesCfg.loadMode = 2;
            afterScroll();
        };
        var onload = function() {
            if (isCompleted) return;
            if (Date.now() - started < 999) {
                setTimeout(onload, 999);
                return;
            }
            isCompleted = true;
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
            addEventListener('scroll', altLoadmodeScrollListner, true);
        };
        return {
            _: function() {
                started = Date.now();
                lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
                preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);
                addEventListener('scroll', throttledCheckElements, true);
                addEventListener('resize', throttledCheckElements, true);
                addEventListener('pageshow', function(e) {
                    if (e.persisted) {
                        var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);
                        if (loadingElements.length && loadingElements.forEach) requestAnimationFrame(function() {
                            loadingElements.forEach(function(img) {
                                if (img.complete) unveilElement(img);
                            });
                        });
                    }
                });
                if (window.MutationObserver) new MutationObserver(throttledCheckElements).observe(docElem, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
                else {
                    docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
                    docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
                    setInterval(throttledCheckElements, 999);
                }
                addEventListener('hashchange', throttledCheckElements, true);
                //, 'fullscreenchange'
                [
                    'focus',
                    'mouseover',
                    'click',
                    'load',
                    'transitionend',
                    'animationend'
                ].forEach(function(name) {
                    document[_addEventListener](name, throttledCheckElements, true);
                });
                if (/d$|^c/.test(document.readyState)) onload();
                else {
                    addEventListener('load', onload);
                    document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
                    setTimeout(onload, 20000);
                }
                if (lazysizes.elements.length) {
                    checkElements();
                    rAF._lsFlush();
                } else throttledCheckElements();
            },
            checkElems: throttledCheckElements,
            unveil: unveilElement,
            _aLSL: altLoadmodeScrollListner
        };
    }();
    var autoSizer = function() {
        var autosizesElems;
        var sizeElement = rAFIt(function(elem, parent, event, width) {
            var sources, i, len;
            elem._lazysizesWidth = width;
            width += 'px';
            elem.setAttribute('sizes', width);
            if (regPicture.test(parent.nodeName || '')) {
                sources = parent.getElementsByTagName('source');
                for(i = 0, len = sources.length; i < len; i++)sources[i].setAttribute('sizes', width);
            }
            if (!event.detail.dataAttr) updatePolyfill(elem, event.detail);
        });
        /**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */ var getSizeElement = function(elem, dataAttr, width) {
            var event;
            var parent = elem.parentNode;
            if (parent) {
                width = getWidth(elem, parent, width);
                event = triggerEvent(elem, 'lazybeforesizes', {
                    width: width,
                    dataAttr: !!dataAttr
                });
                if (!event.defaultPrevented) {
                    width = event.detail.width;
                    if (width && width !== elem._lazysizesWidth) sizeElement(elem, parent, event, width);
                }
            }
        };
        var updateElementsSizes = function() {
            var i;
            var len = autosizesElems.length;
            if (len) {
                i = 0;
                for(; i < len; i++)getSizeElement(autosizesElems[i]);
            }
        };
        var debouncedUpdateElementsSizes = debounce(updateElementsSizes);
        return {
            _: function() {
                autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
                addEventListener('resize', debouncedUpdateElementsSizes);
            },
            checkElems: debouncedUpdateElementsSizes,
            updateElem: getSizeElement
        };
    }();
    var init = function() {
        if (!init.i && document.getElementsByClassName) {
            init.i = true;
            autoSizer._();
            loader._();
        }
    };
    setTimeout(function() {
        if (lazySizesCfg.init) init();
    });
    lazysizes = {
        /**
		 * @type { LazySizesConfigPartial }
		 */ cfg: lazySizesCfg,
        autoSizer: autoSizer,
        loader: loader,
        init: init,
        uP: updatePolyfill,
        aC: addClass,
        rC: removeClass,
        hC: hasClass,
        fire: triggerEvent,
        gW: getWidth,
        rAF: rAF
    };
    return lazysizes;
});

},{}],"4TU5q":[function(require,module,exports) {
(function(window, factory) {
    if (!window) return;
    var globalInstall = function() {
        factory(window.lazySizes);
        window.removeEventListener('lazyunveilread', globalInstall, true);
    };
    factory = factory.bind(null, window, window.document);
    if (typeof module == 'object' && module.exports) factory(require('lazysizes'));
    else if (typeof define == 'function' && define.amd) define([
        'lazysizes'
    ], factory);
    else if (window.lazySizes) globalInstall();
    else window.addEventListener('lazyunveilread', globalInstall, true);
})(typeof window != 'undefined' ? window : 0, function(window, document, lazySizes) {
    /*jshint eqnull:true */ 'use strict';
    var polyfill;
    var lazySizesCfg = lazySizes.cfg;
    var img = document.createElement('img');
    var supportSrcset = 'sizes' in img && 'srcset' in img;
    var regHDesc = /\s+\d+h/g;
    var fixEdgeHDescriptor = function() {
        var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
        var forEach = Array.prototype.forEach;
        return function() {
            var img = document.createElement('img');
            var removeHDescriptors = function(source) {
                var ratio, match;
                var srcset = source.getAttribute(lazySizesCfg.srcsetAttr);
                if (srcset) {
                    if (match = srcset.match(regDescriptors)) {
                        if (match[2] == 'w') ratio = match[1] / match[3];
                        else ratio = match[3] / match[1];
                        if (ratio) source.setAttribute('data-aspectratio', ratio);
                        source.setAttribute(lazySizesCfg.srcsetAttr, srcset.replace(regHDesc, ''));
                    }
                }
            };
            var handler = function(e) {
                if (e.detail.instance != lazySizes) return;
                var picture = e.target.parentNode;
                if (picture && picture.nodeName == 'PICTURE') forEach.call(picture.getElementsByTagName('source'), removeHDescriptors);
                removeHDescriptors(e.target);
            };
            var test = function() {
                if (!!img.currentSrc) document.removeEventListener('lazybeforeunveil', handler);
            };
            document.addEventListener('lazybeforeunveil', handler);
            img.onload = test;
            img.onerror = test;
            img.srcset = 'data:,a 1w 1h';
            if (img.complete) test();
        };
    }();
    if (!lazySizesCfg.supportsType) lazySizesCfg.supportsType = function(type /*, elem*/ ) {
        return !type;
    };
    if (window.HTMLPictureElement && supportSrcset) {
        if (!lazySizes.hasHDescriptorFix && document.msElementsFromPoint) {
            lazySizes.hasHDescriptorFix = true;
            fixEdgeHDescriptor();
        }
        return;
    }
    if (window.picturefill || lazySizesCfg.pf) return;
    lazySizesCfg.pf = function(options) {
        var i, len;
        if (window.picturefill) return;
        for(i = 0, len = options.elements.length; i < len; i++)polyfill(options.elements[i]);
    };
    // partial polyfill
    polyfill = (function() {
        var ascendingSort = function(a, b) {
            return a.w - b.w;
        };
        var regPxLength = /^\s*\d+\.*\d*px\s*$/;
        var reduceCandidate = function(srces) {
            var lowerCandidate, bonusFactor;
            var len = srces.length;
            var candidate = srces[len - 1];
            var i = 0;
            for(; i < len; i++){
                candidate = srces[i];
                candidate.d = candidate.w / srces.w;
                if (candidate.d >= srces.d) {
                    if (!candidate.cached && (lowerCandidate = srces[i - 1]) && lowerCandidate.d > srces.d - 0.13 * Math.pow(srces.d, 2.2)) {
                        bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);
                        if (lowerCandidate.cached) lowerCandidate.d += 0.15 * bonusFactor;
                        if (lowerCandidate.d + (candidate.d - srces.d) * bonusFactor > srces.d) candidate = lowerCandidate;
                    }
                    break;
                }
            }
            return candidate;
        };
        var parseWsrcset = function() {
            var candidates;
            var regWCandidates = /(([^,\s].[^\s]+)\s+(\d+)w)/g;
            var regMultiple = /\s/;
            var addCandidate = function(match, candidate, url, wDescriptor) {
                candidates.push({
                    c: candidate,
                    u: url,
                    w: wDescriptor * 1
                });
            };
            return function(input) {
                candidates = [];
                input = input.trim();
                input.replace(regHDesc, '').replace(regWCandidates, addCandidate);
                if (!candidates.length && input && !regMultiple.test(input)) candidates.push({
                    c: input,
                    u: input,
                    w: 99
                });
                return candidates;
            };
        }();
        var runMatchMedia = function() {
            if (runMatchMedia.init) return;
            runMatchMedia.init = true;
            addEventListener('resize', function() {
                var timer;
                var matchMediaElems = document.getElementsByClassName('lazymatchmedia');
                var run = function() {
                    var i, len;
                    for(i = 0, len = matchMediaElems.length; i < len; i++)polyfill(matchMediaElems[i]);
                };
                return function() {
                    clearTimeout(timer);
                    timer = setTimeout(run, 66);
                };
            }());
        };
        var createSrcset = function(elem, isImage) {
            var parsedSet;
            var srcSet = elem.getAttribute('srcset') || elem.getAttribute(lazySizesCfg.srcsetAttr);
            if (!srcSet && isImage) srcSet = !elem._lazypolyfill ? elem.getAttribute(lazySizesCfg.srcAttr) || elem.getAttribute('src') : elem._lazypolyfill._set;
            if (!elem._lazypolyfill || elem._lazypolyfill._set != srcSet) {
                parsedSet = parseWsrcset(srcSet || '');
                if (isImage && elem.parentNode) {
                    parsedSet.isPicture = elem.parentNode.nodeName.toUpperCase() == 'PICTURE';
                    if (parsedSet.isPicture) {
                        if (window.matchMedia) {
                            lazySizes.aC(elem, 'lazymatchmedia');
                            runMatchMedia();
                        }
                    }
                }
                parsedSet._set = srcSet;
                Object.defineProperty(elem, '_lazypolyfill', {
                    value: parsedSet,
                    writable: true
                });
            }
        };
        var getX = function(elem) {
            var dpr = window.devicePixelRatio || 1;
            var optimum = lazySizes.getX && lazySizes.getX(elem);
            return Math.min(optimum || dpr, 2.5, dpr);
        };
        var matchesMedia = function(media) {
            if (window.matchMedia) matchesMedia = function(media) {
                return !media || (matchMedia(media) || {
                }).matches;
            };
            else return !media;
            return matchesMedia(media);
        };
        var getCandidate = function(elem) {
            var sources, i, len, media, source, srces, src, width;
            source = elem;
            createSrcset(source, true);
            srces = source._lazypolyfill;
            if (srces.isPicture) {
                for(i = 0, sources = elem.parentNode.getElementsByTagName('source'), len = sources.length; i < len; i++)if (lazySizesCfg.supportsType(sources[i].getAttribute('type'), elem) && matchesMedia(sources[i].getAttribute('media'))) {
                    source = sources[i];
                    createSrcset(source);
                    srces = source._lazypolyfill;
                    break;
                }
            }
            if (srces.length > 1) {
                width = source.getAttribute('sizes') || '';
                width = regPxLength.test(width) && parseInt(width, 10) || lazySizes.gW(elem, elem.parentNode);
                srces.d = getX(elem);
                if (!srces.src || !srces.w || srces.w < width) {
                    srces.w = width;
                    src = reduceCandidate(srces.sort(ascendingSort));
                    srces.src = src;
                } else src = srces.src;
            } else src = srces[0];
            return src;
        };
        var p = function(elem) {
            if (supportSrcset && elem.parentNode && elem.parentNode.nodeName.toUpperCase() != 'PICTURE') return;
            var candidate = getCandidate(elem);
            if (candidate && candidate.u && elem._lazypolyfill.cur != candidate.u) {
                elem._lazypolyfill.cur = candidate.u;
                candidate.cached = true;
                elem.setAttribute(lazySizesCfg.srcAttr, candidate.u);
                elem.setAttribute('src', candidate.u);
            }
        };
        p.parse = parseWsrcset;
        return p;
    })();
    if (lazySizesCfg.loadedClass && lazySizesCfg.loadingClass) (function() {
        var sels = [];
        [
            'img[sizes$="px"][srcset].',
            'picture > img:not([srcset]).'
        ].forEach(function(sel) {
            sels.push(sel + lazySizesCfg.loadedClass);
            sels.push(sel + lazySizesCfg.loadingClass);
        });
        lazySizesCfg.pf({
            elements: document.querySelectorAll(sels.join(', '))
        });
    })();
});

},{"lazysizes":"cW810"}],"8r8MO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Add component
var Utilities = function() {
    // Set attributes
    var attributes = {
        toggleElementsHide: 'data-hide-selector',
        toggleElementsShow: 'data-show-selector'
    }; // Set selectors
    var selectors = {
        toggleElements: '[data-action-toggle-elements]'
    }; // Add event handler
    function addEventHandler(elem, eventType, handler) {
        if (elem.addEventListener) elem.addEventListener(eventType, handler, false);
        else if (elem.attachEvent) elem.attachEvent('on' + eventType, handler);
    } // Get cookie
    var getCookie = function getCookie(name) {
        var name = name + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == ' ')c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return '';
    }; // Init fluid vids
    var initFluidVids = function initFluidVids() {
        var iframes = document.getElementsByTagName('iframe');
        var players = /youtube|vimeo/;
        for(var i = 0; i < iframes.length; i++){
            var iframe = iframes[i];
            if (iframe.src.search(players) !== -1) {
                var iframeParent = iframe.parentNode; // Return if video has already been made fluid
                if (iframeParent.classList.contains('fluid-vids')) return;
                var wrap = document.createElement('div');
                var videoRatio = 56.25;
                if (iframe.height && iframe.width) videoRatio = iframe.height / iframe.width * 100;
                iframe.style.position = 'absolute';
                iframe.style.top = '0';
                iframe.style.left = '0';
                iframe.width = '100%';
                iframe.height = '100%';
                iframe.classList.add('height-full');
                wrap.className = 'fluid-vids';
                wrap.style.width = '100%';
                wrap.style.position = 'relative';
                wrap.style.paddingTop = videoRatio + '%';
                iframeParent.insertBefore(wrap, iframe);
                wrap.appendChild(iframe);
            }
        }
    }; // Init scrolling tables
    var initScrollingTables = function initScrollingTables() {
        document.querySelectorAll('table.scrolltable').forEach(function(table) {
            var div = document.createElement('div');
            div.style.overflowX = 'auto';
            table.parentNode.insertBefore(div, table);
            div.appendChild(table);
        });
    }; // On load
    var onLoad = function onLoad() {
        // Init fluid vids
        initFluidVids(); // Init scrolling tables
        initScrollingTables(); // Add toggle element event listeners
        document.querySelectorAll(selectors.toggleElements).forEach(function(toggle) {
            return toggle.addEventListener('click', function(e) {
                e.preventDefault();
                toggleElements(toggle.getAttribute(attributes.toggleElementsShow), toggle.getAttribute(attributes.toggleElementsHide));
            });
        });
    }; // Set cookie
    var setCookie = function setCookie(name, value, days) {
        var d = new Date();
        d.setTime(d.getTime() + days * 86400000);
        var expires = 'expires=' + d.toUTCString();
        document.cookie = name + '=' + value + ';' + expires + ';path=/';
    }; // Toggle elements
    var toggleElements = function toggleElements(showSelector, hideSelector) {
        var showElement = document.querySelector(showSelector);
        var hideElement = document.querySelector(hideSelector);
        if (showElement) showElement.classList.remove('hidden');
        if (hideElement) hideElement.classList.add('hidden');
    }; // Init
    onLoad(); // Return
    return {
        addEventHandler: addEventHandler,
        getCookie: getCookie,
        initFluidVids: initFluidVids,
        initScrollingTables: initScrollingTables,
        onLoad: onLoad,
        setCookie: setCookie,
        toggleElements: toggleElements
    };
}(); // Add component to theme
window.Theme = _objectSpread(_objectSpread({
}, window.Theme), {
}, {
    components: _objectSpread(_objectSpread({
    }, window.Theme.components), {
    }, {
        Utilities: Utilities
    })
}); // Export
var _default = Utilities;
exports.default = _default;

},{}],"ggxmq":[function(require,module,exports) {
"use strict";
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var cart = _interopRequireWildcard(require("@shopify/theme-cart"));
var _themeCurrency = require("@shopify/theme-currency");
var _freeGift = _interopRequireDefault(require("./free-gift"));
var _shippingProtection = _interopRequireDefault(require("./shipping-protection"));
var _utilities = _interopRequireDefault(require("./utilities"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Add component
var AjaxCart = function() {
    var config = window.Theme.config;
    var i18n = window.Theme.i18n;
    var discounts = 0; // Set classes
    var classes = {
        hidden: 'hidden'
    }; // Set selectors
    var selectors = {
        addWithAjaxButton: '[data-cart-action="ajax"]',
        checkoutButton: '.js-ajax-checkout-button',
        closeDrawer: '.js-ajax-cart-drawer-close',
        drawer: '.js-ajax-cart-drawer',
        drawerContent: '.js-ajax-cart-drawer-content',
        itemCount: '[data-cart-item-count]',
        openDrawer: '.js-ajax-cart-drawer-open',
        overlay: '.js-ajax-cart-overlay',
        productSuggestion: '[data-product-suggestion]',
        productSuggestionAdd: '[data-action-add-to-cart]',
        removeItem: '.js-ajax-remove-item',
        removeShippingProtectionItem: '.js-ajax-remove-shipping-protection',
        subtotal: '.js-ajax-cart-drawer-subtotal',
        qtyDecrease: '.js-ajax-cart-drawer-qty-decrease',
        qtyIncrease: '.js-ajax-cart-drawer-qty-increase',
        qtyInput: '.js-ajax-cart-drawer-qty-input'
    }; // Add event listeners
    var addEventListeners = function addEventListeners() {
        // Add open listeners
        document.querySelectorAll(selectors.openDrawer).forEach(function(trigger) {
            trigger.addEventListener('click', function(e) {
                e.preventDefault();
                open();
            });
        }); // Add close listeners
        document.querySelectorAll(selectors.closeDrawer).forEach(function(trigger) {
            trigger.addEventListener('click', function(e) {
                e.preventDefault();
                close();
            });
        });
        $(document).keyup(function(e) {
            if (e.key === 'Escape') close();
        }); // Add add item listeners
        document.querySelectorAll(selectors.addWithAjaxButton).forEach(function(trigger) {
            trigger.addEventListener('click', function(e) {
                var form = trigger.closest('form');
                e.preventDefault();
                trigger.blur();
                addItemFromForm(form, trigger);
            });
        }); // Add product suggestion listeners
        document.querySelectorAll(selectors.productSuggestion).forEach(function(element) {
            var variantId = element.getAttribute('data-variant-suggestion');
            if (variantId) element.querySelectorAll(selectors.productSuggestionAdd).forEach(function(trigger) {
                trigger.addEventListener('click', function(e) {
                    e.preventDefault();
                    addUpsellItem(parseInt(variantId));
                });
            });
        });
    }; // Add upsell item
    var addUpsellItem = function addUpsellItem(variantId) {
        if (!variantId) return;
        cart.addItem(variantId).then(function(item) {
            _utilities.default.setCookie("theme_upsell_".concat(variantId), 1, 1);
            return cart.getState();
        }).then(function(state) {
            render(state);
        });
    }; // Add item from form
    var addItemFromForm = function addItemFromForm(form, trigger) {
        if (trigger) trigger.innerHTML = i18n.product.addingToCart;
        cart.addItemFromForm(form).then(function(item) {
            open(); // Update free gift
            _freeGift.default.update(); // Add shipping protection
            if (_shippingProtection.default && window.Theme.config.shippingProtection) {
                if (_utilities.default.getCookie('theme_sp_removed') !== '1') _shippingProtection.default.add();
            } // Update trigger
            if (trigger) {
                trigger.innerHTML = i18n.product.addedToCart;
                setTimeout(function() {
                    trigger.innerHTML = i18n.product.addToCart;
                }, 1000);
            }
        }, function(error) {
            error.json().then(function(body) {
                if (trigger) trigger.innerHTML = i18n.product.addToCart;
            });
        });
    }; // Close
    var close = function close() {
        document.querySelector(selectors.drawer).classList.remove('is-open');
        document.querySelector('html').classList.remove('ajax-cart-is-open');
        document.querySelector('html').classList.remove('overflow-hidden');
        hideOverlay();
    }; // Hide overlay
    var hideOverlay = function hideOverlay() {
        document.querySelector(selectors.overlay).classList.remove('is-open');
    }; // Open
    var open = function open() {
        cart.getState().then(function(state) {
            document.querySelector(selectors.drawer).classList.add('is-open');
            document.querySelector('html').classList.add('ajax-cart-is-open');
            document.querySelector('html').classList.add('overflow-hidden');
            render(state);
            showOverlay();
            _freeGift.default.update(state);
            _shippingProtection.default.render(state);
        });
    }; // Remove item
    var removeItem = function removeItem(key) {
        cart.removeItem(key).then(function(state) {
            render(state);
            _shippingProtection.default.update(state);
        });
    }; // Render
    var render = function render(state) {
        renderItems(state);
        renderItemCounts(state);
        renderSubtotal(state);
        renderUpsell(state);
    }; // Render cart state
    var renderItems = function renderItems(state) {
        if (!state) return;
        var content = document.querySelector(selectors.drawerContent);
        var shippingProtectionElement = false;
        content.innerHTML = '';
        if (state.items.length === 0) content.innerHTML = "<div class=\"text-center\">".concat(i18n.cart.general.emptyHTML, "</div>");
        discounts = 0;
        state.items.forEach(function(item, index) {
            var template = document.createElement('div');
            var badge = '';
            var itemType = '';
            var subtitle = "<div class=\"color-gray-500 font-2xs line-height-2xs mt-1\">".concat(item.variant_title, "</div>");
            var price = item.line_price;
            if (_freeGift.default.isThresholdMet(state) && config && config.freeGift && item.id === config.freeGift.variantID) {
                itemType = 'free-gift';
                badge = "<div class=\"bg-green color-white line-height-2xs mb-2 px-2 py-1 inline-block radius-full uppercase\" style=\"font-size: 11px\">".concat(i18n.cart.general.freeGift, "</div>");
                price -= item.price;
                discounts += item.price;
            }
            if (config.shippingProtection && config.shippingProtection.product.id === item.product_id) {
                itemType = 'shipping-protection';
                shippingProtectionElement = template;
            }
            if (itemType == 'shipping-protection') subtitle = '';
            var lineItem = "<div class=\"flex font-xs mb-4 pb-4\" data-handle=\"".concat(item.handle, "\">\n      <div class=\"flex-shrink-0 pr-4 width-24\"><img src=\"").concat(item.image, "\" /></div>\n      <div class=\"flex-1\">\n        ").concat(badge, "\n        <div class=\"font-600 line-height-2xs\">").concat(item.product_title, "</div>\n        ").concat(subtitle, "\n        <div class=\"color-gray-600 mt-1\" data-price data-base-price=\"").concat(item.line_price, "\">").concat(_themeCurrency.formatMoney(price, '${{ amount }}'), "</div>\n      </div>\n      <div class=\"pl-4 text-center width-24\">\n        <div class=\"ajax-cart-drawer-qty flex line-height-4xs ").concat(itemType == 'shipping-protection' ? 'hidden' : '', "\">\n          <button type=\"button\" style=\"border-radius:0\" class=\"js-ajax-cart-drawer-qty-decrease appearance-none bg-white border-right-0 color-gray-500 font-m mr--1px px-2 hover:bg-gray-200 hover:color-gray-800\" style=\"border-top-left-radius:4px;border-bottom-left-radius:4px;\" data-item-key=\"").concat(item.key, " data-qty=\"").concat(item.quantity, "\">\n          <span aria-hidden=\"true\">\u2212</span>\n          <span class=\"hidden\">Reduce item quantity by one</span>\n          </button>\n          \n          <input type=\"text\" name=\"item-qty\" class=\"js-ajax-cart-drawer-qty-input appearance-none border-left-0 border-right-0 outline-none px-1 text-center width-full\" value=\"").concat(item.quantity, "\" data-item-key=\"").concat(item.key, "\" aria-label=\"quantity\">\n          \n          <button type=\"button\" class=\"js-ajax-cart-drawer-qty-increase appearance-none bg-white border-left-0 color-gray-500 font-m ml--1px px-2 hover:bg-gray-200 hover:color-gray-800\" style=\"border-top-right-radius:4px;border-bottom-right-radius:4px;\" data-item-key=\"").concat(item.key, "\" data-qty=\"").concat(item.quantity, "\">\n          <span aria-hidden=\"true\">+</span>\n          <span class=\"hidden\">Increase item quantity by one</span>\n          </button>\n        </div>\n        <div class=\"").concat(itemType == 'shipping-protection' ? 'js-ajax-remove-shipping-protection' : 'js-ajax-remove-item', " color-gray-500 cursor-pointer pt-1 hover:color-gray hover:underline\" style=\"font-size: 12px;\" data-item-key=\"").concat(item.key, "\">Remove</div>\n      </div>\n    </div>");
            template.innerHTML = lineItem;
            content.appendChild(template);
            template.querySelectorAll(selectors.qtyInput).forEach(function(element) {
                element.addEventListener('change', function(e) {
                    element.disabled = true;
                    updateItem(item.key, {
                        quantity: parseInt(e.target.value)
                    });
                });
            });
            template.querySelectorAll(selectors.qtyIncrease).forEach(function(element) {
                element.addEventListener('click', function(e) {
                    element.disabled = true;
                    e.preventDefault();
                    var input = template.querySelector(selectors.qtyInput);
                    var val = parseInt(input.value) + 1;
                    input.value = val < 0 ? 0 : val;
                    updateItem(item.key, {
                        quantity: val
                    });
                });
            });
            template.querySelectorAll(selectors.qtyDecrease).forEach(function(element) {
                element.addEventListener('click', function(e) {
                    element.disabled = true;
                    e.preventDefault();
                    var input = template.querySelector(selectors.qtyInput);
                    var val = parseInt(input.value) - 1;
                    input.value = val < 0 ? 0 : val;
                    updateItem(item.key, {
                        quantity: val
                    });
                });
            });
            template.querySelectorAll(selectors.removeItem).forEach(function(element) {
                element.addEventListener('click', function(e) {
                    element.disabled = true;
                    e.preventDefault();
                    removeItem(item.key, {
                        quantity: 0
                    });
                });
            });
            template.querySelectorAll(selectors.removeShippingProtectionItem).forEach(function(element) {
                element.addEventListener('click', function(e) {
                    e.preventDefault();
                    _shippingProtection.default.remove(true);
                });
            });
        }); // Move shipping protection to bottom
        if (shippingProtectionElement) // content.insertBefore(shippingProtectionElement, content.children[0])
        content.appendChild(shippingProtectionElement);
    }; // Render cart state
    var renderItemCounts = function renderItemCounts(state) {
        document.querySelectorAll(selectors.itemCount).forEach(function(element) {
            element.classList.remove(classes.hidden);
            element.innerHTML = state.item_count;
        });
    }; // Render subtotal
    var renderSubtotal = function renderSubtotal(state) {
        var price = state.total_price - discounts;
        document.querySelectorAll(selectors.subtotal).forEach(function(element) {
            element.setAttribute('data-base-price', price);
            element.innerHTML = _themeCurrency.formatMoney(price, '${{ amount }}');
        });
    }; // Render upsell
    var renderUpsell = function renderUpsell(state) {
        if (!state) return;
        var drawer = document.querySelector(selectors.drawer);
        if (drawer) drawer.querySelectorAll(selectors.productSuggestion).forEach(function(element) {
            var variantId = element.getAttribute('data-variant-suggestion'); // if (Utilities.getCookie(`theme_upsell_${variantId}`) != 1) {
            element.classList.remove(classes.hidden); // }
            if (variantId) state.items.forEach(function(item) {
                if (parseInt(item.variant_id) === parseInt(variantId)) element.classList.add(classes.hidden);
            });
        });
    }; // Show overlay
    var showOverlay = function showOverlay() {
        document.querySelector(selectors.overlay).classList.add('is-open');
    }; // Update item
    var updateItem = function updateItem(key, _ref) {
        var quantity = _ref.quantity, properties = _ref.properties;
        cart.updateItem(key, {
            quantity: quantity
        }).then(function(state) {
            render(state);
            _freeGift.default.update(state);
            _shippingProtection.default.update(state);
        });
    }; // Update cart state
    var updateState = function updateState() {
        return cart.getState().then(function(state) {
            return render(state);
        });
    }; // On load
    var onLoad = function onLoad() {
        document.addEventListener('DOMContentLoaded', function() {
            addEventListeners();
        });
    }; // Init
    onLoad(); // Return
    return {
        addEventListeners: addEventListeners,
        addItemFromForm: addItemFromForm,
        close: close,
        hideOverlay: hideOverlay,
        open: open,
        removeItem: removeItem,
        render: render,
        renderItems: renderItems,
        renderItemCounts: renderItemCounts,
        renderSubtotal: renderSubtotal,
        showOverlay: showOverlay,
        updateItem: updateItem,
        updateState: updateState,
        onLoad: onLoad
    };
}(window.Theme); // Add component to theme
window.Theme = _objectSpread(_objectSpread({
}, window.Theme), {
}, {
    components: _objectSpread(_objectSpread({
    }, window.Theme.components), {
    }, {
        AjaxCart: AjaxCart
    })
}); // Export
var _default = AjaxCart;
exports.default = _default;

},{"@shopify/theme-cart":"lmOa0","@shopify/theme-currency":"jEdpj","./free-gift":"eBK23","./shipping-protection":"bLBRl","./utilities":"8r8MO"}],"lmOa0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the state object of the cart
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */ parcelHelpers.export(exports, "getState", ()=>getState
);
/**
 * Returns the index of the cart line item
 * @param {string} key The unique key of the line item
 * @returns {Promise} Resolves with the index number of the line item
 */ parcelHelpers.export(exports, "getItemIndex", ()=>getItemIndex
);
/**
 * Fetches the line item object
 * @param {string} key The unique key of the line item
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */ parcelHelpers.export(exports, "getItem", ()=>getItem
);
/**
 * Add a new line item to the cart
 * @param {number} id The variant's unique ID
 * @param {object} options Optional values to pass to /cart/add.js
 * @param {number} options.quantity The quantity of items to be added to the cart
 * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */ parcelHelpers.export(exports, "addItem", ()=>addItem
);
/**
 * Add a new line item to the cart from a product form
 * @param {object} form DOM element which is equal to the <form> node
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */ parcelHelpers.export(exports, "addItemFromForm", ()=>addItemFromForm
);
/**
 * Changes the quantity and/or properties of an existing line item.
 * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
 * @param {object} options Optional values to pass to /cart/add.js
 * @param {number} options.quantity The quantity of items to be added to the cart
 * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */ parcelHelpers.export(exports, "updateItem", ()=>updateItem
);
/**
 * Removes a line item from the cart
 * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */ parcelHelpers.export(exports, "removeItem", ()=>removeItem
);
/**
 * Sets all quantities of all line items in the cart to zero. This does not remove cart attributes nor the cart note.
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */ parcelHelpers.export(exports, "clearItems", ()=>clearItems
);
/**
 * Gets all cart attributes
 * @returns {Promise} Resolves with the cart attributes object
 */ parcelHelpers.export(exports, "getAttributes", ()=>getAttributes
);
/**
 * Sets all cart attributes
 * @returns {Promise} Resolves with the cart state object
 */ parcelHelpers.export(exports, "updateAttributes", ()=>updateAttributes
);
/**
 * Clears all cart attributes
 * @returns {Promise} Resolves with the cart state object
 */ parcelHelpers.export(exports, "clearAttributes", ()=>clearAttributes
);
/**
 * Gets cart note
 * @returns {Promise} Resolves with the cart note string
 */ parcelHelpers.export(exports, "getNote", ()=>getNote
);
/**
 * Sets cart note
 * @returns {Promise} Resolves with the cart state object
 */ parcelHelpers.export(exports, "updateNote", ()=>updateNote
);
/**
 * Clears cart note
 * @returns {Promise} Resolves with the cart state object
 */ parcelHelpers.export(exports, "clearNote", ()=>clearNote
);
/**
 * Get estimated shipping rates.
 * @returns {Promise} Resolves with response of /cart/shipping_rates.json (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-shipping-rates)
 */ parcelHelpers.export(exports, "getShippingRates", ()=>getShippingRates
);
/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */ var _request = require("./request");
var _validate = require("./validate");
function getState() {
    return _request.cart();
}
function getItemIndex(key) {
    _validate.key(key);
    return _request.cart().then(function(state) {
        var index = -1;
        state.items.forEach(function(item, i) {
            index = item.key === key ? i + 1 : index;
        });
        if (index === -1) return Promise.reject(new Error('Theme Cart: Unable to match line item with provided key'));
        return index;
    });
}
function getItem(key) {
    _validate.key(key);
    return _request.cart().then(function(state) {
        var lineItem = null;
        state.items.forEach(function(item) {
            lineItem = item.key === key ? item : lineItem;
        });
        if (lineItem === null) return Promise.reject(new Error('Theme Cart: Unable to match line item with provided key'));
        return lineItem;
    });
}
function addItem(id, options) {
    options = options || {
    };
    _validate.id(id);
    return _request.cartAdd(id, options.quantity, options.properties);
}
function addItemFromForm(form) {
    _validate.form(form);
    var formData = new FormData(form);
    _validate.id(parseInt(formData.get('id'), 10));
    return _request.cartAddFromForm(formData);
}
function updateItem(key, options) {
    _validate.key(key);
    _validate.options(options);
    return getItemIndex(key).then(function(line) {
        return _request.cartChange(line, options);
    });
}
function removeItem(key) {
    _validate.key(key);
    return getItemIndex(key).then(function(line) {
        return _request.cartChange(line, {
            quantity: 0
        });
    });
}
function clearItems() {
    return _request.cartClear();
}
function getAttributes() {
    return _request.cart().then(function(state) {
        return state.attributes;
    });
}
function updateAttributes(attributes) {
    return _request.cartUpdate({
        attributes: attributes
    });
}
function clearAttributes() {
    return getAttributes().then(function(attributes) {
        for(var key in attributes)attributes[key] = '';
        return updateAttributes(attributes);
    });
}
function getNote() {
    return _request.cart().then(function(state) {
        return state.note;
    });
}
function updateNote(note) {
    return _request.cartUpdate({
        note: note
    });
}
function clearNote() {
    return _request.cartUpdate({
        note: ''
    });
}
function getShippingRates() {
    return _request.cartShippingRates();
}

},{"./request":"7Wqbv","./validate":"fmW5Y","@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"7Wqbv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cart", ()=>cart
);
parcelHelpers.export(exports, "cartAdd", ()=>cartAdd
);
parcelHelpers.export(exports, "cartAddFromForm", ()=>cartAddFromForm
);
parcelHelpers.export(exports, "cartChange", ()=>cartChange
);
parcelHelpers.export(exports, "cartClear", ()=>cartClear
);
parcelHelpers.export(exports, "cartUpdate", ()=>cartUpdate
);
parcelHelpers.export(exports, "cartShippingRates", ()=>cartShippingRates
);
function getDefaultRequestConfig() {
    return JSON.parse(JSON.stringify({
        credentials: 'same-origin',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json;'
        }
    }));
}
function fetchJSON(url, config) {
    return fetch(url, config).then(function(response) {
        if (!response.ok) throw response;
        return response.json();
    });
}
function cart() {
    return fetchJSON('/cart.js', getDefaultRequestConfig());
}
function cartAdd(id, quantity, properties) {
    var config = getDefaultRequestConfig();
    config.method = 'POST';
    config.body = JSON.stringify({
        id: id,
        quantity: quantity,
        properties: properties
    });
    return fetchJSON('/cart/add.js', config);
}
function cartAddFromForm(formData) {
    var config = getDefaultRequestConfig();
    delete config.headers['Content-Type'];
    config.method = 'POST';
    config.body = formData;
    return fetchJSON('/cart/add.js', config);
}
function cartChange(line, options) {
    var config = getDefaultRequestConfig();
    options = options || {
    };
    config.method = 'POST';
    config.body = JSON.stringify({
        line: line,
        quantity: options.quantity,
        properties: options.properties
    });
    return fetchJSON('/cart/change.js', config);
}
function cartClear() {
    var config = getDefaultRequestConfig();
    config.method = 'POST';
    return fetchJSON('/cart/clear.js', config);
}
function cartUpdate(body) {
    var config = getDefaultRequestConfig();
    config.method = 'POST';
    config.body = JSON.stringify(body);
    return fetchJSON('/cart/update.js', config);
}
function cartShippingRates() {
    return fetchJSON('/cart/shipping_rates.json', getDefaultRequestConfig());
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"fmW5Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "key", ()=>key
);
parcelHelpers.export(exports, "quantity", ()=>quantity
);
parcelHelpers.export(exports, "id", ()=>id
);
parcelHelpers.export(exports, "properties", ()=>properties
);
parcelHelpers.export(exports, "form", ()=>form
);
parcelHelpers.export(exports, "options", ()=>options
);
function key(key) {
    if (typeof key !== 'string' || key.split(':').length !== 2) throw new TypeError('Theme Cart: Provided key value is not a string with the format xxx:xxx');
}
function quantity(quantity) {
    if (typeof quantity !== 'number' || isNaN(quantity)) throw new TypeError('Theme Cart: An object which specifies a quantity or properties value is required');
}
function id(id) {
    if (typeof id !== 'number' || isNaN(id)) throw new TypeError('Theme Cart: Variant ID must be a number');
}
function properties(properties) {
    if (typeof properties !== 'object') throw new TypeError('Theme Cart: Properties must be an object');
}
function form(form) {
    if (!(form instanceof HTMLFormElement)) throw new TypeError('Theme Cart: Form must be an instance of HTMLFormElement');
}
function options(options) {
    if (typeof options !== 'object') throw new TypeError('Theme Cart: Options must be an object');
    if (typeof options.quantity === 'undefined' && typeof options.properties === 'undefined') throw new Error('Theme Cart: You muse define a value for quantity or properties');
    if (typeof options.quantity !== 'undefined') quantity(options.quantity);
    if (typeof options.properties !== 'undefined') properties(options.properties);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"jEdpj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */ parcelHelpers.export(exports, "formatMoney", ()=>formatMoney
);
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */ const moneyFormat = '${{amount}}';
function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
        if (isNaN(number) || number == null) return 0;
        number = (number / 100).toFixed(precision);
        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        const centsAmount = parts[1] ? decimal + parts[1] : '';
        return dollarsAmount + centsAmount;
    }
    switch(formatString.match(placeholderRegex)[1]){
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"eBK23":[function(require,module,exports) {
"use strict";
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var cart = _interopRequireWildcard(require("@shopify/theme-cart"));
var _ajaxCart = _interopRequireDefault(require("./ajax-cart"));
var _utilities = _interopRequireDefault(require("./utilities"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Add component
var FreeGift = function() {
    var config = window.Theme.config.freeGift;
    var i18n = window.Theme.i18n; // Set cooke data
    var cookies = {
        added: 'theme_fg_added'
    }; // Is cookie set
    var isCookieSet = function isCookieSet() {
        return parseInt(_utilities.default.getCookie(cookies.added)) === 1;
    }; // Is gift in cart
    var isGiftInCart = function isGiftInCart(state, id) {
        if (!state || !id) return;
        return state.items.filter(function(item) {
            return item.id === id;
        }).length > 0;
    }; // Is threshold met
    var isThresholdMet = function isThresholdMet(state) {
        if (!state || !config) return;
        return state.items_subtotal_price >= config.subtotalThreshold;
    }; // Update
    var update = function update(state) {
        if (!state || !config) return;
        var id = config.variantID;
        if (state) {
            if (!isThresholdMet(state) || isCookieSet() || isGiftInCart(state, id)) return;
            return cart.addItem(id, {
                quantity: 1
            }).then(function(item) {
                _utilities.default.setCookie(cookies.added, 1, 1);
                _ajaxCart.default.updateState();
                return;
            }).catch(function(error) {
                console.log(error);
            });
        } else // Get cart state
        cart.getState().then(function(state) {
            if (!isThresholdMet(state) || isCookieSet() || isGiftInCart(state, id)) return;
            cart.addItem(id, {
                quantity: 1
            }).then(function(item) {
                _utilities.default.setCookie(cookies.added, 1, 1);
                _ajaxCart.default.updateState();
                return;
            }).catch(function(error) {
                console.log(error);
            });
        });
    }; // Return
    return {
        isCookieSet: isCookieSet,
        isGiftInCart: isGiftInCart,
        isThresholdMet: isThresholdMet,
        update: update
    };
}(); // Add component to theme
window.Theme = _objectSpread(_objectSpread({
}, window.Theme), {
}, {
    components: _objectSpread(_objectSpread({
    }, window.Theme.components), {
    }, {
        FreeGift: FreeGift
    })
}); // Export
var _default = FreeGift;
exports.default = _default;

},{"@shopify/theme-cart":"lmOa0","./ajax-cart":"ggxmq","./utilities":"8r8MO"}],"bLBRl":[function(require,module,exports) {
"use strict";
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var cart = _interopRequireWildcard(require("@shopify/theme-cart"));
var _themeCurrency = require("@shopify/theme-currency");
var _ajaxCart = _interopRequireDefault(require("./ajax-cart"));
var _utilities = _interopRequireDefault(require("./utilities"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Add component
var ShippingProtection = function() {
    var config = window.Theme.config.shippingProtection;
    var isCartPage = window.Theme.current.template == 'cart'; // Set classes
    var classes = {
        hidden: 'hidden'
    }; // Set cooke data
    var cookies = {
        removed: 'theme_sp_removed'
    }; // Set selectors
    var selectors = {
        instance: '[data-shipping-protection]',
        toggle: '[data-toggle-shipping-protection]',
        price: '[data-shipping-protection-price]'
    }; // Add
    var add = function add() {
        return cart.getState().then(function(state) {
            var item = getItem(state);
            var variant = getVariant(state); // Add or update item
            if (getItem(state)) return update(state);
            else return variant && !item ? cart.addItem(variant.id, {
                quantity: 1
            }) : false;
        }).then(function(item) {
            _utilities.default.setCookie(cookies.removed, 0);
            return cart.getState();
        }).then(function(state) {
            render(state);
            _ajaxCart.default.render(state);
            return state;
        }).catch(function(error) {
            console.log(error);
        });
    }; // Add event listeners
    var addEventListeners = function addEventListeners() {
        document.addEventListener('DOMContentLoaded', function() {
            document.querySelectorAll(selectors.instance).forEach(function(instance) {
                instance.querySelectorAll(selectors.toggle).forEach(function(toggle) {
                    toggle.addEventListener('change', function(e) {
                        if (e.target.checked) add().then(function() {
                            return renderCartPage();
                        });
                        else remove(true).then(function() {
                            return renderCartPage();
                        });
                        e.target.setAttribute('disabled', '');
                        instance.querySelector('.er-switch-control').style.opacity = 0.4;
                        instance.querySelector('.er-switch-control').style.cursor = 'not-allowed';
                    });
                });
            });
        });
    }; // Get item
    var getItem = function getItem(state) {
        if (!state) return;
        return state.items.find(function(i) {
            return i.product_id === config.product.id;
        }) || false;
    }; // Get variant
    var getVariant = function getVariant(state) {
        if (!state) return;
        var price = 0;
        var product = config.product;
        var total = state.total_price;
        var variants = product.variants;
        var variant = variants[variants.length - 1]; // Deduct protection amount if in cart
        state.items.forEach(function(item) {
            if (item.product_id == product.id) total -= item.final_line_price;
        }); // Set exact protection price
        price = Math.round(total * parseFloat(config.rate) / 100); // Find variant with price closest to exact protection price
        for(var i = 0; i <= variants.length - 1; i++)if (price <= variants[i].price) {
            variant = variants[i];
            break;
        }
         // Return
        return variant;
    }; // Remove
    var remove = function remove(setRemovedCookie) {
        // Set removed cookie
        if (setRemovedCookie === true) _utilities.default.setCookie(cookies.removed, 1, 0.25);
        return cart.getState().then(function(state) {
            var item = getItem(state);
            return item ? cart.removeItem(item.key) : false;
        }).then(function(state) {
            render(state);
            _ajaxCart.default.render(state);
            return state;
        }).catch(function(error) {
            console.log(error);
        });
    }; // Render
    var render = function render(state) {
        var item = getItem(state);
        var variant = getVariant(state);
        document.querySelectorAll(selectors.instance).forEach(function(instance) {
            var toggle = instance.querySelector(selectors.toggle);
            var price = instance.querySelector(selectors.price);
            if (price && variant) price.innerHTML = _themeCurrency.formatMoney(variant.price);
            toggle.checked = toggle && item ? 'checked' : '';
            instance.classList.remove(classes.hidden);
            toggle.removeAttribute('disabled');
            instance.querySelector('.er-switch-control').style.opacity = 1;
            instance.querySelector('.er-switch-control').style.cursor = 'pointer';
        });
    }; // Render cart page
    var renderCartPage = function renderCartPage(state) {
        if (isCartPage) window.location.reload(true);
    }; // Update
    var update = function update(state) {
        if (!state) return; // Just re-render and return if the item is already in the cart or the removed cookie has been set
        if (getItem(state).id === getVariant(state).id || _utilities.default.getCookie('theme_sp_removed') === '1') {
            render(state);
            return;
        } // Remove the item if it's the only one in the cart
        if (state.items.length === 1 && getItem(state) !== false) {
            remove();
            return;
        } // Remove the incorrect item and add the correct one
        remove().then(function(state) {
            return add().then(function() {
                return renderCartPage();
            });
        });
        return;
    }; // On load
    var onLoad = function onLoad() {
        addEventListeners(); // Render cart page
        if (isCartPage) cart.getState().then(function(state) {
            return update(state);
        });
    }; // Init
    onLoad(); // Return
    return {
        add: add,
        render: render,
        remove: remove,
        update: update
    };
}(); // Add component to theme
window.Theme = _objectSpread(_objectSpread({
}, window.Theme), {
}, {
    components: _objectSpread(_objectSpread({
    }, window.Theme.components), {
    }, {
        ShippingProtection: ShippingProtection
    })
}); // Export
var _default = ShippingProtection;
exports.default = _default;

},{"@shopify/theme-cart":"lmOa0","@shopify/theme-currency":"jEdpj","./ajax-cart":"ggxmq","./utilities":"8r8MO"}],"4P1lh":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Add component
var HeaderSearch = function() {
    var utilities = window.Theme.components.Utilities;
    var searchBg, searchElement, searchElementToggles, searchInput; // Set classes
    var classes = {
        hidden: 'hidden'
    }; // Set selectors
    var selectors = {
        searchBg: '[data-header-search-bg]',
        searchElement: '[data-header-search]',
        searchElementToggle: '[data-toggle-header-search]',
        searchInput: '[data-header-search] input'
    }; // Hide
    var hide = function hide() {
        searchBg.classList.add(classes.hidden);
        searchElement.classList.add(classes.hidden);
        searchInput.value = '';
        window.Theme.components.PredictiveSearch.instances[0].reset();
    }; // On load
    var onLoad = function onLoad() {
        searchBg = document.querySelector(selectors.searchBg);
        searchElement = document.querySelector(selectors.searchElement);
        searchElementToggles = document.querySelectorAll(selectors.searchElementToggle);
        searchInput = document.querySelector(selectors.searchInput);
        searchElementToggles.forEach(function(searchElementToggle) {
            searchElementToggle.addEventListener('click', function(e) {
                e.preventDefault();
                toggle();
            });
        });
        searchBg.addEventListener('click', function() {
            return hide();
        });
    }; // Show
    var show = function show() {
        searchBg.classList.remove(classes.hidden);
        searchElement.classList.remove(classes.hidden);
        searchInput.focus();
        window.Theme.components.NavPrimary.instances[0].close();
        utilities.addEventHandler(searchInput, 'keyup', function(e) {
            if (e.keyCode == 27) hide();
        });
    }; // Toggle
    var toggle = function toggle() {
        searchElement.classList.contains(classes.hidden) ? show() : hide();
    }; // Init
    onLoad(); // Return
    return {
        hide: hide,
        onLoad: onLoad,
        show: show,
        toggle: toggle
    };
}(); // Add component to theme
window.Theme = _objectSpread(_objectSpread({
}, window.Theme), {
}, {
    components: _objectSpread(_objectSpread({
    }, window.Theme.components), {
    }, {
        HeaderSearch: HeaderSearch
    })
}); // Export
var _default = HeaderSearch;
exports.default = _default;

},{}],"j41Og":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Add component
var Image = function() {
    // On load
    var onLoad = function onLoad() {
        addLazyLoading();
    }; // Add lazy loading
    var addLazyLoading = function addLazyLoading() {
        var images = document.querySelectorAll('img');
        for(var i = 0; i < images.length; i++){
            var image = images[i];
            image.setAttribute('loading', 'lazy');
            image.setAttribute('sizes', 'auto');
        }
    }; // Init
    onLoad(); // Return
    return {
        addLazyLoading: addLazyLoading,
        onLoad: onLoad
    };
}(); // Add component to theme
window.Theme = _objectSpread(_objectSpread({
}, window.Theme), {
}, {
    components: _objectSpread(_objectSpread({
    }, window.Theme.components), {
    }, {
        Image: Image
    })
}); // Export
var _default = Image;
exports.default = _default;

},{}],"cG7Js":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Add component
var JumpMenu = function() {
    var instances = []; // Set selectors
    var selectors = {
        component: 'select[data-jump-menu]'
    }; // Initialize instances
    var init = function init() {
        document.querySelectorAll(selectors.component).forEach(function(container) {
            // Build instance
            var instance = function() {
                // On load
                var onLoad = function onLoad() {
                    var baseURL = container.getAttribute('data-jump-menu-base-url');
                    var param = container.getAttribute('data-jump-menu-param'); // Set value
                    var searchParams = new URLSearchParams(window.location.search);
                    if (searchParams.has(param)) container.value = searchParams.get(param); // Add change listener
                    container.addEventListener('change', function(e) {
                        var value = container.options[container.selectedIndex].value;
                        window.location.href = "".concat(baseURL, "?").concat(param, "=").concat(value);
                    });
                }; // Init
                onLoad(); // Return
                return {
                    container: container,
                    onLoad: onLoad
                };
            }(); // Add instance to instances array
            instances.push(instance);
        });
    }; // Init
    init(); // Return
    return {
        init: init,
        instances: instances,
        selectors: selectors
    };
}(); // Add component to theme
window.Theme = _objectSpread(_objectSpread({
}, window.Theme), {
}, {
    components: _objectSpread(_objectSpread({
    }, window.Theme.components), {
    }, {
        JumpMenu: JumpMenu
    })
}); // Export
var _default = JumpMenu;
exports.default = _default;

},{}],"fI3HX":[function(require,module,exports) {
"use strict";
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var basicLightbox = _interopRequireWildcard(require("basiclightbox"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Add component
var Lightbox = function() {
    var instances = []; // Set attributes
    var attributes = {
        template: 'data-action-lightbox'
    }; // Set classes
    var classes = {
        overflowHidden: 'overflow-hidden'
    }; // Set selectors
    var selectors = {
        close: '[data-close-lightbox]',
        component: '[data-action-lightbox]',
        placeholder: '.basicLightbox__placeholder'
    }; // Initialize instances
    var init = function init() {
        document.querySelectorAll(selectors.component).forEach(function(link) {
            // Build instance
            var instance = function() {
                var lightbox; // On load
                var onLoad = function onLoad() {
                    var templateSelector = link.getAttribute(attributes.template);
                    var template = document.querySelector(templateSelector);
                    if (!template) return;
                    lightbox = basicLightbox.create(template, {
                        onShow: function onShow(instance) {
                            document.querySelector('body').classList.add(classes.overflowHidden);
                            document.onkeydown = function(evt) {
                                evt = evt || window.event;
                                if (evt.keyCode == 27) instance.close();
                            };
                            instance.element().querySelectorAll(selectors.close).forEach(function(trigger) {
                                trigger.addEventListener('click', function(e) {
                                    e.preventDefault();
                                    instance.close();
                                });
                            });
                        },
                        onClose: function onClose(instance) {
                            document.querySelector('body').classList.remove(classes.overflowHidden);
                        }
                    });
                    link.addEventListener('click', function(e) {
                        e.preventDefault();
                        if (lightbox) lightbox.show();
                    });
                }; // Init
                onLoad(); // Return
                return {
                    lightbox: lightbox,
                    link: link,
                    onLoad: onLoad
                };
            }(); // Add instance to instances array
            instances.push(instance);
        });
    }; // Init
    document.addEventListener('DOMContentLoaded', function() {
        init();
    }); // Return
    return {
        init: init,
        instances: instances,
        selectors: selectors
    };
}(); // Add component to theme
window.Theme = _objectSpread(_objectSpread({
}, window.Theme), {
}, {
    components: _objectSpread(_objectSpread({
    }, window.Theme.components), {
    }, {
        Lightbox: Lightbox
    })
}); // Export
var _default = Lightbox;
exports.default = _default;

},{"basiclightbox":"gHCRv"}],"gHCRv":[function(require,module,exports) {
var global = arguments[3];
!function(e) {
    if ("object" == typeof exports && "undefined" != typeof module) module.exports = e();
    else if ("function" == typeof define && define.amd) define([], e);
    else ("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).basicLightbox = e();
}(function() {
    return (function e(n, t, o) {
        function r(c, u) {
            if (!t[c]) {
                if (!n[c]) {
                    var s = "function" == typeof require && undefined;
                    if (!u && s) return s(c, !0);
                    if (i) return i(c, !0);
                    var a = new Error("Cannot find module '" + c + "'");
                    throw a.code = "MODULE_NOT_FOUND", a;
                }
                var l = t[c] = {
                    exports: {
                    }
                };
                n[c][0].call(l.exports, function(e) {
                    return r(n[c][1][e] || e);
                }, l, l.exports, e, n, t, o);
            }
            return t[c].exports;
        }
        for(var i = "function" == typeof require && undefined, c = 0; c < o.length; c++)r(o[c]);
        return r;
    })({
        1: [
            function(e, n, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.create = t.visible = void 0;
                var o = function(e) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], t = document.createElement("div");
                    return t.innerHTML = e.trim(), !0 === n ? t.children : t.firstChild;
                }, r = function(e, n) {
                    var t = e.children;
                    return 1 === t.length && t[0].tagName === n;
                }, i = function(e) {
                    return null != (e = e || document.querySelector(".basicLightbox")) && !0 === e.ownerDocument.body.contains(e);
                };
                t.visible = i;
                t.create = function(e, n) {
                    var t = function(e, n) {
                        var t = o('\n\t\t<div class="basicLightbox '.concat(n.className, '">\n\t\t\t<div class="basicLightbox__placeholder" role="dialog"></div>\n\t\t</div>\n\t')), i = t.querySelector(".basicLightbox__placeholder");
                        e.forEach(function(e) {
                            return i.appendChild(e);
                        });
                        var c = r(i, "IMG"), u = r(i, "VIDEO"), s = r(i, "IFRAME");
                        return !0 === c && t.classList.add("basicLightbox--img"), !0 === u && t.classList.add("basicLightbox--video"), !0 === s && t.classList.add("basicLightbox--iframe"), t;
                    }(e = function(e) {
                        var n = "string" == typeof e, t = e instanceof HTMLElement == 1;
                        if (!1 === n && !1 === t) throw new Error("Content must be a DOM element/node or string");
                        return !0 === n ? Array.from(o(e, !0)) : "TEMPLATE" === e.tagName ? [
                            e.content.cloneNode(!0)
                        ] : Array.from(e.children);
                    }(e), n = function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
                        };
                        if (null == (e = Object.assign({
                        }, e)).closable && (e.closable = !0), null == e.className && (e.className = ""), null == e.onShow && (e.onShow = function() {
                        }), null == e.onClose && (e.onClose = function() {
                        }), "boolean" != typeof e.closable) throw new Error("Property `closable` must be a boolean");
                        if ("string" != typeof e.className) throw new Error("Property `className` must be a string");
                        if ("function" != typeof e.onShow) throw new Error("Property `onShow` must be a function");
                        if ("function" != typeof e.onClose) throw new Error("Property `onClose` must be a function");
                        return e;
                    }(n)), c = function(e) {
                        return !1 !== n.onClose(u) && (function(e, n) {
                            return e.classList.remove("basicLightbox--visible"), setTimeout(function() {
                                return !1 === i(e) || e.parentElement.removeChild(e), n();
                            }, 410), !0;
                        })(t, function() {
                            if ("function" == typeof e) return e(u);
                        });
                    };
                    !0 === n.closable && t.addEventListener("click", function(e) {
                        e.target === t && c();
                    });
                    var u = {
                        element: function() {
                            return t;
                        },
                        visible: function() {
                            return i(t);
                        },
                        show: function(e) {
                            return !1 !== n.onShow(u) && (function(e, n) {
                                return document.body.appendChild(e), setTimeout(function() {
                                    requestAnimationFrame(function() {
                                        return e.classList.add("basicLightbox--visible"), n();
                                    });
                                }, 10), !0;
                            })(t, function() {
                                if ("function" == typeof e) return e(u);
                            });
                        },
                        close: c
                    };
                    return u;
                };
            },
            {
            }
        ]
    }, {
    }, [
        1
    ])(1);
});

},{}],"47p9h":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Add component
var Nav = function() {
    var instances = []; // Set attributes
    var attributes = {
        isOpen: 'data-is-open'
    }; // Set selectors
    var selectors = {
        component: '[data-nav]',
        node: '[data-node]'
    }; // Initialize instances
    var init = function init() {
        document.querySelectorAll(selectors.component).forEach(function(container) {
            // Build instance
            var instance = function() {
                // Close nodes
                var closeNodes = function closeNodes() {
                    container.querySelectorAll(':scope > ul > li' + selectors.node).forEach(function(node) {
                        node.removeAttribute(attributes.isOpen);
                        node.querySelector(':scope > ul').classList.add('hidden', 'm:hidden');
                    });
                }; // On load
                var onLoad = function onLoad() {
                    // Handle node click
                    container.querySelectorAll(':scope > ul > li' + selectors.node).forEach(function(node) {
                        var nodeLink = node.querySelector(':scope > a');
                        nodeLink.addEventListener('click', function(e) {
                            onNodeLinkClick(e, nodeLink);
                        });
                    });
                }; // On node link click
                var onNodeLinkClick = function onNodeLinkClick(e, nodeLink) {
                    var node = nodeLink.parentElement;
                    if (node.hasAttribute(attributes.isOpen)) return;
                    e.preventDefault();
                    closeNodes();
                    openNode(node);
                }; // Open node
                var openNode = function openNode(node) {
                    var menu = node.querySelector(':scope > ul');
                    document.addEventListener('click', function(e) {
                        if (!container.contains(e.target)) closeNodes();
                    });
                    node.setAttribute(attributes.isOpen, '');
                    menu.classList.remove('hidden', 'm:hidden');
                }; // Init
                onLoad(); // Return
                return {
                    close: close,
                    closeNodes: closeNodes,
                    container: container,
                    onLoad: onLoad,
                    open: open
                };
            }(); // Add instance to instances array
            instances.push(instance);
        });
    }; // Init
    init(); // Return
    return {
        init: init,
        instances: instances,
        selectors: selectors
    };
}(); // Add component to theme
window.Theme = _objectSpread(_objectSpread({
}, window.Theme), {
}, {
    components: _objectSpread(_objectSpread({
    }, window.Theme.components), {
    }, {
        Nav: Nav
    })
}); // Export
var _default = Nav;
exports.default = _default;

},{}],"2gSkO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Add component
var NavPrimary = function() {
    var instances = []; // Set attributes
    var attributes = {
        isOpen: 'data-is-open'
    }; // Set classes
    var classes = {
        htmlIsOpen: 'nav-primary-open'
    }; // Set selectors
    var selectors = {
        component: '[data-nav-primary]',
        node: '[data-node]',
        toggle: '[data-toggle-nav-primary]',
        toggleIconClose: '[data-toggle-icon-close]',
        toggleIconOpen: '[data-toggle-icon-open]'
    }; // Initialize instances
    var init = function init() {
        document.querySelectorAll(selectors.component).forEach(function(container) {
            // Build instance
            var instance = function() {
                // Close menu
                var close = function close() {
                    var toggleIconClose = selectors.toggleIconClose, toggleIconOpen = selectors.toggleIconOpen;
                    var toggle = document.querySelector(selectors.toggle);
                    document.querySelector('html').classList.remove(classes.htmlIsOpen);
                    container.removeAttribute(attributes.isOpen);
                    container.classList.add('hidden');
                    toggle.querySelector(toggleIconClose).classList.add('hidden');
                    toggle.querySelector(toggleIconOpen).classList.remove('hidden');
                    closeNodes();
                }; // Close nodes
                var closeNodes = function closeNodes() {
                    container.querySelectorAll(':scope > ul > li' + selectors.node).forEach(function(node) {
                        node.removeAttribute(attributes.isOpen);
                        node.querySelector(':scope > ul').classList.add('hidden', 'm:hidden');
                    });
                }; // On load
                var onLoad = function onLoad() {
                    setSubmenuPositions(); // Handle toggle click
                    document.querySelector(selectors.toggle).addEventListener('click', function(e) {
                        e.preventDefault();
                        toggle();
                    }); // Handle node click
                    container.querySelectorAll(':scope > ul > li' + selectors.node).forEach(function(node) {
                        var nodeLink = node.querySelector(':scope > a');
                        nodeLink.addEventListener('click', function(e) {
                            onNodeLinkClick(e, nodeLink);
                        });
                    }); // Add resize event listeners
                    document.addEventListener('DOMContentLoaded', function() {
                        var windowWidth = window.innerWidth;
                        window.addEventListener('resize', function() {
                            if (window.innerWidth != windowWidth) {
                                windowWidth = window.innerWidth;
                                closeNodes();
                                setSubmenuPositions();
                            }
                        });
                    });
                }; // On node link click
                var onNodeLinkClick = function onNodeLinkClick(e, nodeLink) {
                    var node = nodeLink.parentElement;
                    if (node.hasAttribute(attributes.isOpen)) return;
                    if (window.innerWidth < 900) {
                        e.preventDefault();
                        closeNodes();
                        openNode(node);
                    }
                }; // Open menu
                var open = function open() {
                    var toggleIconClose = selectors.toggleIconClose, toggleIconOpen = selectors.toggleIconOpen;
                    var toggle = document.querySelector(selectors.toggle);
                    document.querySelector('html').classList.add(classes.htmlIsOpen);
                    container.setAttribute(attributes.isOpen, '');
                    container.classList.remove('hidden');
                    toggle.querySelector(toggleIconClose).classList.remove('hidden');
                    toggle.querySelector(toggleIconOpen).classList.add('hidden');
                }; // Open node
                var openNode = function openNode(node) {
                    var menu = node.querySelector(':scope > ul');
                    node.setAttribute(attributes.isOpen, '');
                    menu.classList.remove('hidden', 'm:hidden');
                }; // Toggle menu
                var toggle = function toggle() {
                    container.hasAttribute(attributes.isOpen) ? close() : open();
                }; // Set submenu positions
                var setSubmenuPositions = function setSubmenuPositions() {
                    var nodes = container.querySelectorAll(':scope > ul > ' + selectors.node);
                    nodes.forEach(function(node) {
                        var menu = node.querySelector(':scope > ul');
                        menu.classList.remove('right-0');
                        menu.style.display = 'block';
                        if (menu.getBoundingClientRect().left + window.scrollX + menu.offsetWidth > window.innerWidth - 20) menu.classList.add('right-0');
                        menu.setAttribute('style', '');
                    });
                }; // Init
                onLoad(); // Return
                return {
                    close: close,
                    closeNodes: closeNodes,
                    container: container,
                    onLoad: onLoad,
                    open: open,
                    setSubmenuPositions: setSubmenuPositions,
                    toggle: toggle
                };
            }(); // Add instance to instances array
            instances.push(instance);
        });
    }; // Init
    init(); // Return
    return {
        init: init,
        instances: instances,
        selectors: selectors
    };
}(); // Add component to theme
window.Theme = _objectSpread(_objectSpread({
}, window.Theme), {
}, {
    components: _objectSpread(_objectSpread({
    }, window.Theme.components), {
    }, {
        NavPrimary: NavPrimary
    })
}); // Export
var _default = NavPrimary;
exports.default = _default;

},{}],"gK8W9":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var cart = _interopRequireWildcard(require("@shopify/theme-cart"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
// Add component
var OrderDeadline = function() {
    var config = window.Theme.config.orderDeadline; // Set classes
    var classes = {
        hidden: 'hidden'
    }; // Selectors
    var selectors = {
        component: '[data-order-deadline]',
        remaining: '[data-order-deadline-remaining] span',
        ships: '[data-order-deadline-ships] span'
    };
    var DateTime;
    var cutoffDate;
    var shipDate; // Init
    var init = function init() {
        if (!config) return;
        var dateOffset = 0;
        var settingIndex = 0;
        DateTime = luxon.DateTime; // Set cutoff date
        config.cutoffDates.map(function(date, i) {
            if (date[0] == false) return;
            var dateTime = DateTime.fromObject({
                weekday: date[0],
                hour: date[1],
                second: 0,
                zone: 'America/Los_Angeles'
            }); // If the date is in the past add a week
            if (dateTime < DateTime.local()) dateTime = dateTime.plus({
                days: 7
            }); // If the date is closest to now
            if (dateOffset == 0 || dateTime.diffNow().milliseconds < dateOffset) {
                dateOffset = dateTime.diffNow().milliseconds;
                settingIndex = i;
                cutoffDate = dateTime;
            }
        }); // Set ship date
        shipDate = DateTime.fromObject({
            weekday: config.shipDates[settingIndex][0] != false ? config.shipDates[settingIndex][0] : config.shipDates[0][0],
            hour: 0,
            second: 0,
            zone: 'America/Los_Angeles'
        }); // Set ship date week offset
        if (config.shipDates[settingIndex][1] > 1) shipDate = shipDate.plus({
            days: 7 * config.shipDates[settingIndex][1]
        });
         // If the ship date is before the cutoff date add one week
        if (shipDate < cutoffDate) shipDate = shipDate.plus({
            days: 7
        });
         // Set cart attributes
        setCartAttributes(); // Render components
        renderComponents();
    }; // Get time to next cutoff
    var getTimeToNextCutoff = function getTimeToNextCutoff() {
        return cutoffDate.diff(DateTime.local(), [
            'days',
            'hours',
            'minutes'
        ]);
    }; // Get ship date
    var getShipDate = function getShipDate() {
        return shipDate;
    }; // Get ship date formatted
    var getShipDateFormatted = function getShipDateFormatted() {
        return shipDate.toFormat('cccc, ') + shipDate.toFormat('d') + getDateSuffix(shipDate.toFormat('d')) + shipDate.toFormat(' LLLL');
    }; // Get date suffix
    var getDateSuffix = function getDateSuffix(date) {
        if (date > 3 && date < 21) return 'th';
        switch(date % 10){
            case 1:
                return 'st';
            case 2:
                return 'nd';
            case 3:
                return 'rd';
            default:
                return 'th';
        }
    }; // Render components
    var renderComponents = function renderComponents() {
        var timeToNextCutoff = getTimeToNextCutoff();
        document.querySelectorAll(selectors.component).forEach(function(component) {
            // Render time to next cutoff
            component.querySelectorAll(selectors.remaining).forEach(function(remainingElement) {
                remainingElement.innerHTML = Math.floor(timeToNextCutoff.days) + ' Days ' + Math.floor(timeToNextCutoff.hours) + ' Hrs ' + Math.floor(timeToNextCutoff.minutes) + ' Mins ';
            }); // Render ship date
            component.querySelectorAll(selectors.ships).forEach(function(remainingElement) {
                remainingElement.innerHTML = getShipDateFormatted();
            }); // Show component
            component.classList.remove(classes.hidden);
        });
    }; // Set cart attributes
    var setCartAttributes = function setCartAttributes() {
        var date = getShipDateFormatted();
        if (date) cart.updateAttributes({
            'order-ship-date': date
        }).then(function(state) {
        });
    }; // On load
    var onLoad = function onLoad() {
        window.addEventListener('DOMContentLoaded', function() {
            if ((typeof luxon === "undefined" ? "undefined" : _typeof(luxon)) != 'object') return;
            init();
        });
    }; // Init
    onLoad(); // Return
    return {
        config: config,
        init: init,
        getShipDate: getShipDate,
        getShipDateFormatted: getShipDateFormatted,
        getTimeToNextCutoff: getTimeToNextCutoff,
        onLoad: onLoad,
        renderComponents: renderComponents,
        setCartAttributes: setCartAttributes
    };
}(); // Add component to theme
window.Theme = _objectSpread(_objectSpread({
}, window.Theme), {
}, {
    components: _objectSpread(_objectSpread({
    }, window.Theme.components), {
    }, {
        OrderDeadline: OrderDeadline
    })
}); // Export
var _default = OrderDeadline;
exports.default = _default;

},{"@shopify/theme-cart":"lmOa0"}],"l4zyu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _themePredictiveSearch = _interopRequireDefault(require("@shopify/theme-predictive-search"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Add component
var PredictiveSearch = function() {
    var i18n = window.Theme.i18n.search;
    var instances = [];
    var utilities = window.Theme.components.Utilities; // Set attributes
    var attributes = {
        close: 'data-close-predictive-search-results',
        searchResults: 'data-predictive-search-results',
        loading: 'data-predictive-search-loading'
    }; // Set classes
    var classes = {
        hidden: 'hidden'
    }; // Set selectors
    var selectors = {
        component: 'input[data-predictive-search]'
    }; // Initialize instances
    var init = function init() {
        document.querySelectorAll(selectors.component).forEach(function(container) {
            // Build instance
            var instance = function() {
                var dataset = container.dataset;
                var currentQuery, loadingElement, resultsElement, searchingTimer;
                var parent = container.parentElement;
                var resultResourceTitleClass = dataset.resultResourceTitleClass;
                var resultClass = dataset.resultClass;
                var resultLinkClass = dataset.resultLinkClass;
                var resultsClass = dataset.resultsClass;
                var searchingTimerPause = 250; // Create theme search
                var themeSearch = new _themePredictiveSearch.default({
                    resources: {
                        type: [
                            'article',
                            'collection',
                            'page',
                            'product'
                        ],
                        limit: 4,
                        options: {
                            fields: 'title,product_type,tag,variants.title'
                        }
                    }
                }); // Build result
                var buildResult = function buildResult(result, resource) {
                    switch(resource){
                        case 'products':
                            return "<div class=\"".concat(resultClass, "\">\n                <a class=\"").concat(resultLinkClass, "\" href=\"").concat(result.url, "\">\n                  <div class=\"flex\">\n                    <div class=\"width-16\">\n                      <img class=\"radius\" src=\"").concat(result.image ? result.image : '', "\" />\n                    </div>\n                    <div class=\"flex-1 pl-8\">\n                      <div>").concat(result.title, "</div>\n                      <div class=\"color-gray-500 font-2xs mt-1\">").concat(result.vendor, "</div>\n                    </div>\n                  </div>\n                </a>\n              </div>");
                        default:
                            return "<div class=\"".concat(resultClass, "\"><a class=\"").concat(resultLinkClass, "\" href=\"").concat(result.url, "\">").concat(result.title, "</a></div>");
                    }
                }; // Create results element
                var createResultsElement = function createResultsElement() {
                    if (parent.querySelector("[".concat(attributes.searchResults, "]"))) return;
                    resultsElement = document.createElement('div');
                    resultsElement.setAttribute('class', resultsClass);
                    resultsElement.setAttribute(attributes.searchResults, '');
                    parent.appendChild(resultsElement);
                }; // Create loading element
                var createLoadingElement = function createLoadingElement() {
                    return "\n          <div class=\"predective-search-loading mx-auto my-4\" data-predictive-search-loading>Loading...</div>\n          <style>\n            .predective-search-loading,\n            .predective-search-loading:after {\n              border-radius: 50%;\n              width: 2.5em;\n              height: 2.5em;\n            }\n            .predective-search-loading {\n              font-size: 10px;\n              position: relative;\n              text-indent: -9999em;\n              border-top: 3px solid rgba(78, 73, 73, 0.2);\n              border-right: 3px solid rgba(78, 73, 73, 0.2);\n              border-bottom: 3px solid rgba(78, 73, 73, 0.2);\n              border-left: 3px solid #4e4949;\n              -webkit-transform: translateZ(0);\n              -ms-transform: translateZ(0);\n              transform: translateZ(0);\n              -webkit-animation: predictiveSearchSpin 500ms infinite linear;\n              animation: predictiveSearchSpin 500ms infinite linear;\n              overflow: hidden;\n            }\n            @-webkit-keyframes predictiveSearchSpin {\n              0% {\n                -webkit-transform: rotate(0deg);\n                transform: rotate(0deg);\n              }\n              100% {\n                -webkit-transform: rotate(360deg);\n                transform: rotate(360deg);\n              }\n            }\n            @keyframes predictiveSearchSpin {\n              0% {\n                -webkit-transform: rotate(0deg);\n                transform: rotate(0deg);\n              }\n              100% {\n                -webkit-transform: rotate(360deg);\n                transform: rotate(360deg);\n              }\n            }\n          </style>";
                }; // On load
                var onLoad = function onLoad() {
                    // Create results element
                    createResultsElement(); // Create loading element
                    loadingElement = createLoadingElement(); // Add event listeners
                    utilities.addEventHandler(container, 'keydown', function(e) {
                        currentQuery = container.value;
                    });
                    utilities.addEventHandler(container, 'keyup', function(e) {
                        // Reset search when esc is pressed
                        if (e.keyCode == 27) {
                            reset();
                            window.Theme.components.HeaderSearch.hide();
                            return;
                        }
                        if (container.value == currentQuery) return; // Show loading
                        renderLoading(); // Reset results if input is cleared
                        if (container.value == '') reset(); // Clear searching timer
                        clearTimeout(searchingTimer); // Create new searching timer
                        searchingTimer = setTimeout(function() {
                            return search(container.value);
                        }, searchingTimerPause);
                    });
                    themeSearch.on('success', function(data) {
                        return renderResults(data);
                    });
                }; // Render loading
                var renderLoading = function renderLoading() {
                    resultsElement.classList.remove(classes.hidden);
                    if (parent.querySelector("[".concat(attributes.loading, "]"))) return;
                    resultsElement.innerHTML = loadingElement;
                }; // Render results
                var renderResults = function renderResults(data) {
                    var results = data.resources.results;
                    var resultsOrder = [
                        'products',
                        'collections',
                        'articles',
                        'pages'
                    ];
                    var resultsFound = false; // Clear results element
                    resultsElement.innerHTML = '';
                    resultsElement.classList.remove(classes.hidden); // Render results
                    for(var i = 0; i < resultsOrder.length; i++){
                        var resource = resultsOrder[i];
                        if (results[resource].length > 0) {
                            resultsFound = true;
                            resultsElement.innerHTML += "<div class=\"".concat(resultResourceTitleClass, "\">").concat(i18n.suggestions[resource], "</div>");
                            for(var j = 0; j < results[resource].length; j++)resultsElement.innerHTML += buildResult(results[resource][j], resource);
                        }
                    } // Render show all results
                    if (resultsFound) resultsElement.innerHTML += "\n            <div class=\"border-top-1 flex font-s line-height-4xs items-center justify-between mt-3 pb-1 pt-2 px-2\">\n              <div class=\"\"><a class=\"color-black text-decoration-none hover:color-green\" href=\"/search?q=".concat(data.query, "\">").concat(i18n.results.show, " <strong>").concat(data.query, "</strong></a></div>\n              <div class=\"text-right\"><a class=\"block color-gray-500 font-xl text-decoration-none hover:color-black\" href=\"#\" ").concat(attributes.close, ">\xD7</a></div>\n            </div>");
                    else resultsElement.innerHTML += "\n            <div class=\"flex font-s line-height-4xs items-center justify-between p-2\">\n              <div class=\"color-black\">".concat(i18n.results.none, " <strong>").concat(data.query, "</strong></div>\n              <div class=\"text-right\"><a class=\"block color-gray-500 font-xl  text-decoration-none hover:color-black\" href=\"#\" ").concat(attributes.close, ">\xD7</a></div>\n            </div>");
                     // Add close event listener
                    parent.querySelector("[".concat(attributes.close, "]")).addEventListener('click', function() {
                        reset();
                        window.Theme.components.HeaderSearch.hide();
                    });
                }; // Reset
                var reset = function reset() {
                    container.value = '';
                    resultsElement.innerHTML = '';
                    resultsElement.classList.add(classes.hidden);
                }; // Search
                var search = function search(query) {
                    return themeSearch.query(query);
                }; // Init
                onLoad(); // Return
                return {
                    createResultsElement: createResultsElement,
                    onLoad: onLoad,
                    reset: reset,
                    search: search,
                    renderResults: renderResults
                };
            }(); // Add instance to instances array
            instances.push(instance);
        });
    }; // Init
    init(); // Return
    return {
        init: init,
        instances: instances,
        selectors: selectors
    };
}(); // Add component to theme
window.Theme = _objectSpread(_objectSpread({
}, window.Theme), {
}, {
    components: _objectSpread(_objectSpread({
    }, window.Theme.components), {
    }, {
        PredictiveSearch: PredictiveSearch
    })
}); // Export
var _default = PredictiveSearch;
exports.default = _default;

},{"@shopify/theme-predictive-search":"aQ0nC"}],"aQ0nC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validate = require("./validate");
var _request = require("./request");
var _requestDefault = parcelHelpers.interopDefault(_request);
var _utilities = require("./utilities");
var DEBOUNCE_RATE = 10;
var requestDebounced = _utilities.debounce(_requestDefault.default, DEBOUNCE_RATE);
function PredictiveSearch(config) {
    if (!config) throw new TypeError("No config object was specified");
    var configParameters = config;
    this._retryAfter = null;
    this._currentQuery = null;
    this.dispatcher = new _utilities.Dispatcher();
    this.cache = new _utilities.Cache({
        bucketSize: 40
    });
    this.searchPath = configParameters.search_path || "/search";
    if (configParameters.search_path) delete configParameters['search_path'];
    this.configParams = _utilities.objectToQueryParams(configParameters);
}
exports.default = PredictiveSearch;
PredictiveSearch.SEARCH_PATH = "/search";
PredictiveSearch.TYPES = {
    PRODUCT: "product",
    PAGE: "page",
    ARTICLE: "article",
    COLLECTION: "collection"
};
PredictiveSearch.FIELDS = {
    AUTHOR: "author",
    BODY: "body",
    PRODUCT_TYPE: "product_type",
    TAG: "tag",
    TITLE: "title",
    VARIANTS_BARCODE: "variants.barcode",
    VARIANTS_SKU: "variants.sku",
    VARIANTS_TITLE: "variants.title",
    VENDOR: "vendor"
};
PredictiveSearch.UNAVAILABLE_PRODUCTS = {
    SHOW: "show",
    HIDE: "hide",
    LAST: "last"
};
PredictiveSearch.prototype.query = function query(query) {
    try {
        _validate.validateQuery(query);
    } catch (error) {
        this.dispatcher.dispatch("error", error);
        return;
    }
    if (query === "") return this;
    this._currentQuery = normalizeQuery(query);
    var cacheResult = this.cache.get(this._currentQuery);
    if (cacheResult) {
        this.dispatcher.dispatch("success", cacheResult);
        return this;
    }
    requestDebounced(this.searchPath, this.configParams, query, (function(result) {
        this.cache.set(normalizeQuery(result.query), result);
        if (normalizeQuery(result.query) === this._currentQuery) {
            this._retryAfter = null;
            this.dispatcher.dispatch("success", result);
        }
    }).bind(this), (function(error) {
        if (error.retryAfter) this._retryAfter = error.retryAfter;
        this.dispatcher.dispatch("error", error);
    }).bind(this));
    return this;
};
PredictiveSearch.prototype.on = function on(eventName, callback) {
    this.dispatcher.on(eventName, callback);
    return this;
};
PredictiveSearch.prototype.off = function on(eventName, callback) {
    this.dispatcher.off(eventName, callback);
    return this;
};
function normalizeQuery(query) {
    if (typeof query !== "string") return null;
    return query.trim().replace(" ", "-").toLowerCase();
}

},{"./validate":"2Wd3a","./request":"egg8d","./utilities":"gweyB","@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"2Wd3a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateQuery", ()=>validateQuery
);
function validateQuery(query) {
    var error;
    if (query === null || query === undefined) {
        error = new TypeError("'query' is missing");
        error.type = "argument";
        throw error;
    }
    if (typeof query !== "string") {
        error = new TypeError("'query' is not a string");
        error.type = "argument";
        throw error;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"egg8d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _customError = require("./utilities/CustomError");
function request(searchPath, configParams, query, onSuccess, onError) {
    var xhr = new XMLHttpRequest();
    var route = searchPath + '/suggest.json';
    xhr.onreadystatechange = function() {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if (xhr.status >= 500) {
                onError(new _customError.ServerError());
                return;
            }
            if (xhr.status === 404) {
                onError(new _customError.NotFoundError(xhr.status));
                return;
            }
            if (typeof contentType !== "string" || contentType.toLowerCase().match("application/json") === null) {
                onError(new _customError.ContentTypeError(xhr.status));
                return;
            }
            if (xhr.status === 417) {
                try {
                    var invalidParameterJson = JSON.parse(xhr.responseText);
                    onError(new _customError.InvalidParameterError(xhr.status, invalidParameterJson.message, invalidParameterJson.description));
                } catch (error) {
                    onError(new _customError.JsonParseError(xhr.status));
                }
                return;
            }
            if (xhr.status === 422) {
                try {
                    var expectationFailedJson = JSON.parse(xhr.responseText);
                    onError(new _customError.ExpectationFailedError(xhr.status, expectationFailedJson.message, expectationFailedJson.description));
                } catch (error) {
                    onError(new _customError.JsonParseError(xhr.status));
                }
                return;
            }
            if (xhr.status === 429) {
                try {
                    var throttledJson = JSON.parse(xhr.responseText);
                    onError(new _customError.ThrottledError(xhr.status, throttledJson.message, throttledJson.description, xhr.getResponseHeader("Retry-After")));
                } catch (error) {
                    onError(new _customError.JsonParseError(xhr.status));
                }
                return;
            }
            if (xhr.status === 200) {
                try {
                    var res = JSON.parse(xhr.responseText);
                    res.query = query;
                    onSuccess(res);
                } catch (error) {
                    onError(new _customError.JsonParseError(xhr.status));
                }
                return;
            }
            try {
                var genericErrorJson = JSON.parse(xhr.responseText);
                onError(new _customError.GenericError(xhr.status, genericErrorJson.message, genericErrorJson.description));
            } catch (error) {
                onError(new _customError.JsonParseError(xhr.status));
            }
            return;
        }
    };
    xhr.open("get", route + "?q=" + encodeURIComponent(query) + "&" + configParams);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send();
}
exports.default = request;

},{"./utilities/CustomError":"6b7kX","@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"6b7kX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GenericError", ()=>GenericError
);
parcelHelpers.export(exports, "NotFoundError", ()=>NotFoundError
);
parcelHelpers.export(exports, "ServerError", ()=>ServerError
);
parcelHelpers.export(exports, "ContentTypeError", ()=>ContentTypeError
);
parcelHelpers.export(exports, "JsonParseError", ()=>JsonParseError
);
parcelHelpers.export(exports, "ThrottledError", ()=>ThrottledError
);
parcelHelpers.export(exports, "InvalidParameterError", ()=>InvalidParameterError
);
parcelHelpers.export(exports, "ExpectationFailedError", ()=>ExpectationFailedError
);
function GenericError() {
    var error = Error.call(this);
    error.name = "Server error";
    error.message = "Something went wrong on the server";
    error.status = 500;
    return error;
}
function NotFoundError(status) {
    var error = Error.call(this);
    error.name = "Not found";
    error.message = "Not found";
    error.status = status;
    return error;
}
function ServerError() {
    var error = Error.call(this);
    error.name = "Server error";
    error.message = "Something went wrong on the server";
    error.status = 500;
    return error;
}
function ContentTypeError(status) {
    var error = Error.call(this);
    error.name = "Content-Type error";
    error.message = "Content-Type was not provided or is of wrong type";
    error.status = status;
    return error;
}
function JsonParseError(status) {
    var error = Error.call(this);
    error.name = "JSON parse error";
    error.message = "JSON syntax error";
    error.status = status;
    return error;
}
function ThrottledError(status, name, message, retryAfter) {
    var error = Error.call(this);
    error.name = name;
    error.message = message;
    error.status = status;
    error.retryAfter = retryAfter;
    return error;
}
function InvalidParameterError(status, name, message) {
    var error = Error.call(this);
    error.name = name;
    error.message = message;
    error.status = status;
    return error;
}
function ExpectationFailedError(status, name, message) {
    var error = Error.call(this);
    error.name = name;
    error.message = message;
    error.status = status;
    return error;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"gweyB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cache", ()=>_cacheDefault.default
);
parcelHelpers.export(exports, "Dispatcher", ()=>_dispatcherDefault.default
);
parcelHelpers.export(exports, "debounce", ()=>_debounceDefault.default
);
parcelHelpers.export(exports, "objectToQueryParams", ()=>_objectToQueryParamsDefault.default
);
var _cache = require("./Cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _dispatcher = require("./Dispatcher");
var _dispatcherDefault = parcelHelpers.interopDefault(_dispatcher);
var _debounce = require("./debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _objectToQueryParams = require("./objectToQueryParams");
var _objectToQueryParamsDefault = parcelHelpers.interopDefault(_objectToQueryParams);

},{"./Cache":"kwLN7","./Dispatcher":"cAVdp","./debounce":"bFjug","./objectToQueryParams":"j4I0G","@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"kwLN7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function Cache(config) {
    this._store = {
    };
    this._keys = [];
    if (config && config.bucketSize) this.bucketSize = config.bucketSize;
    else this.bucketSize = 20;
}
exports.default = Cache;
Cache.prototype.set = function(key, value) {
    if (this.count() >= this.bucketSize) {
        var deleteKey = this._keys.splice(0, 1);
        this.delete(deleteKey);
    }
    this._keys.push(key);
    this._store[key] = value;
    return this._store;
};
Cache.prototype.get = function(key) {
    return this._store[key];
};
Cache.prototype.has = function(key) {
    return Boolean(this._store[key]);
};
Cache.prototype.count = function() {
    return Object.keys(this._store).length;
};
Cache.prototype.delete = function(key) {
    var exists = Boolean(this._store[key]);
    delete this._store[key];
    return exists && !this._store[key];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"cAVdp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function Dispatcher() {
    this.events = {
    };
}
exports.default = Dispatcher;
Dispatcher.prototype.on = function(eventName, callback) {
    var event = this.events[eventName];
    if (!event) {
        event = new DispatcherEvent(eventName);
        this.events[eventName] = event;
    }
    event.registerCallback(callback);
};
Dispatcher.prototype.off = function(eventName, callback) {
    var event = this.events[eventName];
    if (event && event.callbacks.indexOf(callback) > -1) {
        event.unregisterCallback(callback);
        if (event.callbacks.length === 0) delete this.events[eventName];
    }
};
Dispatcher.prototype.dispatch = function(eventName, payload) {
    var event = this.events[eventName];
    if (event) event.fire(payload);
};
function DispatcherEvent(eventName) {
    this.eventName = eventName;
    this.callbacks = [];
}
DispatcherEvent.prototype.registerCallback = function(callback) {
    this.callbacks.push(callback);
};
DispatcherEvent.prototype.unregisterCallback = function(callback) {
    var index = this.callbacks.indexOf(callback);
    if (index > -1) this.callbacks.splice(index, 1);
};
DispatcherEvent.prototype.fire = function(payload) {
    var callbacks = this.callbacks.slice(0);
    callbacks.forEach(function(callback) {
        callback(payload);
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"bFjug":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function debounce(func, wait) {
    var timeout = null;
    return function() {
        var context = this;
        var args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            timeout = null;
            func.apply(context, args);
        }, wait || 0);
    };
}
exports.default = debounce;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"j4I0G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function objectToQueryParams(obj, parentKey) {
    var output = "";
    parentKey = parentKey || null;
    Object.keys(obj).forEach(function(key) {
        var outputKey = key + "=";
        if (parentKey) outputKey = parentKey + "[" + key + "]";
        switch(trueTypeOf(obj[key])){
            case "object":
                output += objectToQueryParams(obj[key], parentKey ? outputKey : key);
                break;
            case "array":
                output += outputKey + "=" + obj[key].join(",") + "&";
                break;
            default:
                if (parentKey) outputKey += "=";
                output += outputKey + encodeURIComponent(obj[key]) + "&";
                break;
        }
    });
    return output;
}
exports.default = objectToQueryParams;
function trueTypeOf(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"gJwdl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Add component
var Slideshow = function() {
    var instances = []; // Set attributes
    var attributes = {
        active: 'data-active',
        autoplay: 'data-autoplay',
        transitionSpeed: 'data-transition-speed'
    }; // Set selectors
    var selectors = {
        component: '[data-slideshow]',
        nextSlide: '[data-next-slide]',
        previousSlide: '[data-previous-slide]',
        slide: '[data-slide]',
        slides: '[data-slides]'
    }; // Initialize instances
    var init = function init() {
        document.querySelectorAll(selectors.component).forEach(function(container) {
            // Build instance
            var instance = function() {
                var autoplay = container.getAttribute(attributes.autoplay) || false;
                var slides = container.querySelectorAll(selectors.slide);
                var slidesContainer = container.querySelector(selectors.slides);
                var slideCount = slides.length;
                var transitionSpeed = container.getAttribute(attributes.transitionSpeed) || 300;
                var currentSlide = 0;
                var initialX = null;
                var initialY = null;
                var slideInterval = null; // Move to slide
                var moveToSlide = function moveToSlide(n) {
                    slides[currentSlide].removeAttribute(attributes.active);
                    currentSlide = (n + slideCount) % slideCount;
                    slides[currentSlide].setAttribute(attributes.active, '');
                    setSlideHeight();
                }; // Next slide
                var nextSlide = function nextSlide(e) {
                    moveToSlide(currentSlide + 1);
                    if (e && e.keyCode) {
                        if (e.keyCode == 39) moveToSlide(currentSlide + 1);
                    }
                }; // Previous slide
                var prevSlide = function prevSlide(e) {
                    moveToSlide(currentSlide + -1);
                    if (e && e.keyCode) {
                        if (e.keyCode == 37) moveToSlide(currentSlide + -1);
                    }
                }; // On load
                var onLoad = function onLoad() {
                    var nextSlideButton = container.querySelector(selectors.nextSlide);
                    var previousSlideButton = container.querySelector(selectors.previousSlide);
                    moveToSlide(currentSlide); // Add event listeners
                    container.addEventListener('click', function() {
                        setAutoplay(false);
                    });
                    if (nextSlideButton) nextSlideButton.addEventListener('click', nextSlide);
                    if (previousSlideButton) previousSlideButton.addEventListener('click', prevSlide); // Add keyboard controls
                    document.body.addEventListener('keydown', nextSlide, false);
                    document.body.addEventListener('keydown', prevSlide, false); // Add resize listeners
                    window.addEventListener('resize', setSlideHeight); // Add touch listeners
                    container.addEventListener('touchmove', onTouchMove, false);
                    container.addEventListener('touchstart', onTouchStart, false); // Set transitions
                    setTransitions(transitionSpeed); // Set autoplay
                    setAutoplay(autoplay);
                }; // On touch move
                function onTouchMove(e) {
                    if (initialX === null) return;
                    if (initialY === null) return;
                    var currentX = e.touches[0].clientX;
                    var currentY = e.touches[0].clientY;
                    var diffX = initialX - currentX;
                    var diffY = initialY - currentY;
                    e.preventDefault();
                    setAutoplay(false);
                    if (Math.abs(diffX) > Math.abs(diffY)) {
                        if (diffX > 0) moveToSlide(currentSlide + 1);
                        else moveToSlide(currentSlide + -1);
                    }
                    initialX = null;
                    initialY = null;
                } // On touch start
                function onTouchStart(e) {
                    initialX = e.touches[0].clientX;
                    initialY = e.touches[0].clientY;
                } // Set autoplay
                var setAutoplay = function setAutoplay(autoplay) {
                    if (!isNaN(parseInt(autoplay))) slideInterval = setInterval(nextSlide, autoplay);
                    else {
                        clearInterval(slideInterval);
                        slideInterval = 0;
                    }
                }; // Set slide heighit
                var setSlideHeight = function setSlideHeight(height) {
                    height = height || slides[currentSlide].clientHeight;
                    slidesContainer.style.height = height + 'px';
                }; // Set transitions
                var setTransitions = function setTransitions(speed) {
                    container.style.transition = speed + 'ms';
                    for(var i = 0; i < slides.length; i++)slides[i].style.transition = speed + 'ms';
                }; // Init
                onLoad(); // Return
                return {
                    container: container,
                    moveToSlide: moveToSlide,
                    nextSlide: nextSlide,
                    onLoad: onLoad,
                    prevSlide: prevSlide,
                    setAutoplay: setAutoplay,
                    setSlideHeight: setSlideHeight,
                    setTransitions: setTransitions
                };
            }(); // Add instance to instances array
            instances.push(instance);
        });
    }; // Init
    init(); // Return
    return {
        init: init,
        instances: instances,
        selectors: selectors
    };
}(); // Add component to theme
window.Theme = _objectSpread(_objectSpread({
}, window.Theme), {
}, {
    components: _objectSpread(_objectSpread({
    }, window.Theme.components), {
    }, {
        Slideshow: Slideshow
    })
}); // Export
var _default = Slideshow;
exports.default = _default;

},{}],"13O24":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _require = require('@shopify/theme-sections'), register = _require.register;
var Footer = function() {
    var initFluidVids = window.Theme.components.Utilities.initFluidVids;
    register('footer', {
        // On load
        onLoad: function onLoad() {
            if (typeof initFluidVids === 'function') initFluidVids();
        }
    });
}();
var _default = Footer;
exports.default = _default;

},{"@shopify/theme-sections":"9w7jG"}],"7gkUE":[function(require,module,exports) {
"use strict";
var _themeCurrency = require("@shopify/theme-currency");
var _themeProductForm = require("@shopify/theme-product-form");
var _themeSections = require("@shopify/theme-sections");
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {
            };
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
// Classes
var classes = {
    hidden: 'hidden'
}; // Selectors
var selectors = {
    compareAtPrice: '[data-primary-compare-at-price]',
    price: '[data-primary-price]',
    pricing: '[data-primary-pricing]',
    primaryMedia: '[data-primary-media]',
    primaryMediaVisible: "[data-primary-media]:not(.".concat(classes.hidden, ")"),
    primaryMediaId: function primaryMediaId(id) {
        return "".concat(selectors.primaryMedia, "[data-media-id='").concat(id, "']");
    },
    productForm: '[data-product-form]',
    secondaryMedia: '[data-secondary-media]',
    secondaryMediaId: function secondaryMediaId(id) {
        return "".concat(selectors.secondaryMedia, "[data-media-id='").concat(id, "']");
    },
    secondaryMediaActive: '[data-secondary-media][aria-current]',
    submitButton: '[data-product-form] [data-add-to-cart-button]',
    submitButtonText: '[data-submit-button-text]',
    variantId: 'input[name="id"]'
};
_themeSections.register('product-template', {
    // Get product JSON
    getProductJson: function getProductJson(handle) {
        return fetch("https://".concat(window.Shopify.shop, "/products/").concat(handle, ".js")).then(function(response) {
            return response.json();
        });
    },
    // On load
    onLoad: function onLoad() {
        var _this = this;
        var productFormElement = document.querySelector(selectors.productForm);
        this.getProductJson(productFormElement.dataset.productHandle).then(function(product) {
            _this.product = product;
            _this.productForm = new _themeProductForm.ProductForm(productFormElement, _this.product, {
                onOptionChange: _this.updateSelectedVariant.bind(_this)
            });
            _this.onSecondaryMediaClick = _this.onSecondaryMediaClick.bind(_this);
            _this.container.addEventListener('click', _this.onPrimaryMediaClick);
            _this.container.addEventListener('click', _this.onSecondaryMediaClick);
            _this.updateSelectedVariant();
            _this.renderImageSelectors(_this.productForm);
            _this.renderOptions();
            _this.productForm.optionInputs.forEach(function(input) {
                input.addEventListener('change', function(e) {
                    return _this.renderOptions();
                });
            });
        }, function(err) {
            return console.log(err);
        });
    },
    // On secondary media click
    onSecondaryMediaClick: function onSecondaryMediaClick(e) {
        var secondaryMedia = e.target.closest(selectors.secondaryMedia);
        if (!secondaryMedia) return;
        e.preventDefault();
        this.renderPrimaryMedia(secondaryMedia.dataset.mediaId);
        this.renderSecondaryMedia(secondaryMedia.dataset.mediaId);
    },
    // On unload
    onUnload: function onUnload() {
        this.productForm.destroy();
        section.container.removeEventListener('click', section.onSecondaryMediaClick);
    },
    // Render compare price
    renderComparePrice: function renderComparePrice(variant) {
        if (!variant) return;
        var compareAtPriceElement = this.container.querySelector(selectors.compareAtPrice);
        if (!compareAtPriceElement) return;
        if (variant.compare_at_price > variant.price) {
            compareAtPriceElement.innerText = _themeCurrency.formatMoney(variant.compare_at_price, window.Theme.config.moneyFormat);
            compareAtPriceElement.classList.remove(classes.hidden);
        } else {
            compareAtPriceElement.innerText = '';
            compareAtPriceElement.classList.add(classes.hidden);
        }
    },
    // Render images
    renderImages: function renderImages(variant) {
        if (!variant || !variant.featured_media) return;
        this.renderPrimaryMedia(variant.featured_media.id);
        this.renderSecondaryMedia(variant.featured_media.id);
    },
    // Render image selectors
    renderImageSelectors: function renderImageSelectors() {
        var _this2 = this;
        var optionImages = window.Theme.config.optionImages;
        this.optionTypes = []; // Build data
        this.productForm.optionInputs.forEach(function(input) {
            var handle = input.name.toLowerCase().replace('options[', '').replace(']', '').replace(/[^\w\s]/gi, '').replaceAll(' ', '-');
            if (handle.includes('conductive-lace')) _this2.optionTypes.push({
                input: input,
                imagesKey: 'conductiveLace'
            });
        }); // For each type
        this.optionTypes.forEach(function(optionType, i) {
            var change = new Event('change');
            var input = optionType.input;
            var imageSources = optionImages[optionType.imagesKey]; // Create images element
            var imagesElement = document.createElement('div');
            imagesElement.classList.add('flex', 'flex-wrap', 'mx--1'); // Create options element
            var optionsElement = document.createElement('div'); // Add images element to optionType object
            optionType['imagesElement'] = imagesElement; // For each option
            var _iterator = _createForOfIteratorHelper(input.options), _step;
            try {
                var _loop = function _loop() {
                    var option = _step.value;
                    if (!option.value) return "continue";
                    var optionElement = document.createElement('div'); // Get image source
                    var src = imageSources[Object.keys(imageSources).find(function(key) {
                        return option.text.toLowerCase().includes(key);
                    })];
                    optionElement.setAttribute('data-option-text', option.text);
                    if (src) {
                        optionElement.classList.add('line-height-2xs', 'width-1/6');
                        optionElement.innerHTML = "<div class=\"bg-white border-2 border-gray-300 cursor-pointer line-height-2xs m-1 p-1px radius text-center hover:border-gray-500\"><img class=\"lazyload\" src=\"".concat(src, "\" alt=\"").concat(option.text, "\" loading=\"lazy\" title=\"").concat(option.text, "\" style=\"border-radius:2px\"></div>");
                        imagesElement.appendChild(optionElement);
                    } else {
                        optionsElement.classList.add('my-1');
                        optionElement.classList.add('cursor-pointer', 'font-s', 'line-height-xs', 'inline-block', 'mt-1', 'hover:color-green');
                        optionElement.innerHTML = option.text;
                        optionsElement.appendChild(optionElement);
                    }
                    optionElement.addEventListener('click', function(e) {
                        e.preventDefault();
                        if (option.text.toLowerCase().includes('email')) {
                            window.open('/pages/contact-us', '_blank');
                            return;
                        }
                        if (optionElement.dataset.disabled) return;
                        option.selected = true;
                        _this2.productForm.variant();
                        input.dispatchEvent(change);
                    });
                };
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var _ret = _loop();
                    if (_ret === "continue") continue;
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            input.parentElement.classList.add(classes.hidden);
            input.parentElement.insertAdjacentElement('afterend', optionsElement);
            input.parentElement.insertAdjacentElement('afterend', imagesElement);
        });
    },
    // Render options
    renderOptions: function renderOptions() {
        var inputs = this.productForm.optionInputs;
        var variants = this.productForm.product.variants; // Enable all options in selectors
        inputs.forEach(function(input) {
            var _iterator2 = _createForOfIteratorHelper(input.options), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var option = _step2.value;
                    option.removeAttribute('disabled');
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }); // Disable unavailable options in selectors
        variants.filter(function(_ref) {
            var inventory_quantity = _ref.inventory_quantity;
            return inventory_quantity <= 0;
        }).forEach(function(variant) {
            inputs.forEach(function(input, inputIndex) {
                var _iterator3 = _createForOfIteratorHelper(input.options), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var option = _step3.value;
                        var options = inputs.map(function(i) {
                            return i.value;
                        });
                        options[inputIndex] = option.value;
                        if (options.join(' ') === variant.options.join(' ')) option.setAttribute('disabled', true);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            });
        }); // Update option images
        this.optionTypes.forEach(function(optionType) {
            var imagesElement = optionType.imagesElement;
            var options = optionType.input.options;
            for(var i = 0; i < options.length; i++){
                var imageElement = imagesElement.querySelector("[data-option-text=\"".concat(options[i].text, "\"]"));
                if (!imageElement) continue;
                var imageElementChild = imageElement.children[0]; // Reset image element
                imageElement.removeAttribute('data-disabled', true);
                imageElement.classList.remove('pointer-events-none');
                imageElementChild.classList.add('hover:border-gray-500');
                imageElementChild.classList.remove('border-gray-600', 'opacity-20'); // Disable image element if option is unavailable
                if (options[i].getAttribute('disabled') == 'true') {
                    imageElement.setAttribute('data-disabled', true);
                    imageElement.classList.add('pointer-events-none');
                    imageElementChild.classList.add('opacity-20');
                } // Indicate selected image element
                if (options[i].selected) {
                    imageElementChild.classList.add('border-gray-600');
                    imageElementChild.classList.remove('hover:border-gray-500');
                }
            }
        });
    },
    // Render price
    renderPrice: function renderPrice(variant) {
        var priceElement = this.container.querySelector(selectors.price);
        var pricingElement = this.container.querySelector(selectors.pricing);
        pricingElement.classList.toggle(classes.hidden, !variant);
        if (variant) priceElement.innerText = _themeCurrency.formatMoney(variant.price, window.Theme.config.moneyFormat);
    },
    // Render featured image
    renderPrimaryMedia: function renderPrimaryMedia(id) {
        var active = this.container.querySelector(selectors.primaryMediaVisible);
        var inactive = this.container.querySelector(selectors.primaryMediaId(id));
        active.classList.add(classes.hidden);
        inactive.classList.remove(classes.hidden);
    },
    // Render active secondary media
    renderSecondaryMedia: function renderSecondaryMedia(id) {
        var active = this.container.querySelector(selectors.secondaryMediaId(id));
        var inactive = this.container.querySelector(selectors.secondaryMediaActive);
        if (active === inactive) return;
        active.setAttribute('aria-current', true);
        if (inactive) inactive.removeAttribute('aria-current');
    },
    // Render submit button
    renderSubmitButton: function renderSubmitButton(variant) {
        var submitButton = this.container.querySelector(selectors.submitButton);
        var enabledClass = submitButton.getAttribute('data-enabled-class');
        var disabledClass = submitButton.getAttribute('data-disabled-class');
        if (!variant) {
            submitButton.disabled = true;
            submitButton.innerText = window.Theme.i18n.product.unavailable;
            submitButton.setAttribute('class', disabledClass);
        } else if (variant.available) {
            submitButton.disabled = false;
            submitButton.innerText = window.Theme.i18n.product.addToCart;
            submitButton.setAttribute('class', enabledClass);
        } else {
            submitButton.disabled = true;
            submitButton.innerText = window.Theme.i18n.product.soldOut;
            submitButton.setAttribute('class', disabledClass);
        }
    },
    // Update browser history
    updateBrowserHistory: function updateBrowserHistory(variant) {
        var enableHistoryState = this.productForm.element.dataset.enableHistoryState;
        if (!variant || enableHistoryState !== 'true') return;
        var url = _themeProductForm.getUrlWithVariant(window.location.href, variant.id);
        window.history.replaceState({
            path: url
        }, '', url);
    },
    // Update selected variant
    updateSelectedVariant: function updateSelectedVariant(event) {
        var variant = event ? event.dataset.variant : this.productForm.variant();
        var idInput = this.productForm.element.querySelector(selectors.variantId);
        this.renderSubmitButton(variant);
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        this.renderImages(variant);
        this.renderPrice(variant);
        this.renderComparePrice(variant);
        this.updateBrowserHistory(variant);
    }
});

},{"@shopify/theme-currency":"jEdpj","@shopify/theme-product-form":"hZ9EM","@shopify/theme-sections":"9w7jG"}],"hZ9EM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Public Methods
// -----------------------------------------------------------------------------
/**
 * Returns a URL with a variant ID query parameter. Useful for updating window.history
 * with a new URL based on the currently select product variant.
 * @param {string} url - The URL you wish to append the variant ID to
 * @param {number} id  - The variant ID you wish to append to the URL
 * @returns {string} - The new url which includes the variant ID query parameter
 */ parcelHelpers.export(exports, "getUrlWithVariant", ()=>getUrlWithVariant
);
/**
 * Constructor class that creates a new instance of a product form controller.
 *
 * @param {Element} element - DOM element which is equal to the <form> node wrapping product form inputs
 * @param {Object} product - A product object
 * @param {Object} options - Optional options object
 * @param {Function} options.onOptionChange - Callback for whenever an option input changes
 * @param {Function} options.onQuantityChange - Callback for whenever an quantity input changes
 * @param {Function} options.onPropertyChange - Callback for whenever a property input changes
 * @param {Function} options.onFormSubmit - Callback for whenever the product form is submitted
 */ parcelHelpers.export(exports, "ProductForm", ()=>ProductForm
);
var _listeners = require("./listeners");
var _listenersDefault = parcelHelpers.interopDefault(_listeners);
var _themeProduct = require("@shopify/theme-product");
var selectors = {
    idInput: '[name="id"]',
    optionInput: '[name^="options"]',
    quantityInput: '[name="quantity"]',
    propertyInput: '[name^="properties"]'
};
function getUrlWithVariant(url, id) {
    if (/variant=/.test(url)) return url.replace(/(variant=)[^&]+/, '$1' + id);
    else if (/\?/.test(url)) return url.concat('&variant=').concat(id);
    return url.concat('?variant=').concat(id);
}
function ProductForm(element, product, options) {
    this.element = element;
    this.product = _validateProductObject(product);
    options = options || {
    };
    this._listeners = new _listenersDefault.default();
    this._listeners.add(this.element, 'submit', this._onSubmit.bind(this, options));
    this.optionInputs = this._initInputs(selectors.optionInput, options.onOptionChange);
    this.quantityInputs = this._initInputs(selectors.quantityInput, options.onQuantityChange);
    this.propertyInputs = this._initInputs(selectors.propertyInput, options.onPropertyChange);
}
/**
 * Cleans up all event handlers that were assigned when the Product Form was constructed.
 * Useful for use when a section needs to be reloaded in the theme editor.
 */ ProductForm.prototype.destroy = function() {
    this._listeners.removeAll();
};
/**
 * Getter method which returns the array of currently selected option values
 *
 * @returns {Array} An array of option values
 */ ProductForm.prototype.options = function() {
    return _serializeOptionValues(this.optionInputs, function(item) {
        var regex = /(?:^(options\[))(.*?)(?:\])/;
        item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'
        return item;
    });
};
/**
 * Getter method which returns the currently selected variant, or `null` if variant
 * doesn't exist.
 *
 * @returns {Object|null} Variant object
 */ ProductForm.prototype.variant = function() {
    return _themeProduct.getVariantFromSerializedArray(this.product, this.options());
};
/**
 * Getter method which returns a collection of objects containing name and values
 * of property inputs
 *
 * @returns {Array} Collection of objects with name and value keys
 */ ProductForm.prototype.properties = function() {
    var properties = _serializePropertyValues(this.propertyInputs, function(propertyName) {
        var regex = /(?:^(properties\[))(.*?)(?:\])/;
        var name = regex.exec(propertyName)[2]; // Use just the value between 'properties[' and ']'
        return name;
    });
    return Object.entries(properties).length === 0 ? null : properties;
};
/**
 * Getter method which returns the current quantity or 1 if no quantity input is
 * included in the form
 *
 * @returns {Array} Collection of objects with name and value keys
 */ ProductForm.prototype.quantity = function() {
    return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
};
// Private Methods
// -----------------------------------------------------------------------------
ProductForm.prototype._setIdInputValue = function(value) {
    var idInputElement = this.element.querySelector(selectors.idInput);
    if (!idInputElement) {
        idInputElement = document.createElement('input');
        idInputElement.type = 'hidden';
        idInputElement.name = 'id';
        this.element.appendChild(idInputElement);
    }
    idInputElement.value = value.toString();
};
ProductForm.prototype._onSubmit = function(options, event) {
    event.dataset = this._getProductFormEventData();
    if (event.dataset.variant) this._setIdInputValue(event.dataset.variant.id);
    if (options.onFormSubmit) options.onFormSubmit(event);
};
ProductForm.prototype._onFormEvent = function(cb) {
    if (typeof cb === 'undefined') return Function.prototype;
    return (function(event) {
        event.dataset = this._getProductFormEventData();
        cb(event);
    }).bind(this);
};
ProductForm.prototype._initInputs = function(selector, cb) {
    var elements = Array.prototype.slice.call(this.element.querySelectorAll(selector));
    return elements.map((function(element) {
        this._listeners.add(element, 'change', this._onFormEvent(cb));
        return element;
    }).bind(this));
};
ProductForm.prototype._getProductFormEventData = function() {
    return {
        options: this.options(),
        variant: this.variant(),
        properties: this.properties(),
        quantity: this.quantity()
    };
};
function _serializeOptionValues(inputs, transform) {
    return inputs.reduce(function(options, input) {
        if (input.checked || input.type !== 'radio' && input.type !== 'checkbox' // Or if its any other type of input
        ) options.push(transform({
            name: input.name,
            value: input.value
        }));
        return options;
    }, []);
}
function _serializePropertyValues(inputs, transform) {
    return inputs.reduce(function(properties, input) {
        if (input.checked || input.type !== 'radio' && input.type !== 'checkbox' // Or if its any other type of input
        ) properties[transform(input.name)] = input.value;
        return properties;
    }, {
    });
}
function _validateProductObject(product) {
    if (typeof product !== 'object') throw new TypeError(product + ' is not an object.');
    if (typeof product.variants[0].options === 'undefined') throw new TypeError('Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route');
    return product;
}

},{"./listeners":"aY78E","@shopify/theme-product":"ckR7L","@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"aY78E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function Listeners() {
    this.entries = [];
}
exports.default = Listeners;
Listeners.prototype.add = function(element, event, fn) {
    this.entries.push({
        element: element,
        event: event,
        fn: fn
    });
    element.addEventListener(event, fn);
};
Listeners.prototype.removeAll = function() {
    this.entries = this.entries.filter(function(listener) {
        listener.element.removeEventListener(listener.event, listener.fn);
        return false;
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"ckR7L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a product JSON object when passed a product URL
 * @param {*} url
 */ parcelHelpers.export(exports, "getProductJson", ()=>getProductJson
);
/**
 * Find a match in the project JSON (using a ID number) and return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Number} value Accepts Number (e.g. 6908023078973)
 * @returns {Object} The variant object once a match has been successful. Otherwise null will be return
 */ parcelHelpers.export(exports, "getVariantFromId", ()=>getVariantFromId
);
/**
 * Convert the Object (with 'name' and 'value' keys) into an Array of values, then find a match & return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Object} collection Object with 'name' and 'value' keys (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
 */ parcelHelpers.export(exports, "getVariantFromSerializedArray", ()=>getVariantFromSerializedArray
);
/**
 * Find a match in the project JSON (using Array with option values) and return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Array} options List of submitted values (e.g. ['36', 'Black'])
 * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
 */ parcelHelpers.export(exports, "getVariantFromOptionArray", ()=>getVariantFromOptionArray
);
function getProductJson(handle) {
    return fetch('/products/' + handle + '.js').then(function(response) {
        return response.json();
    });
}
function getVariantFromId(product, value) {
    _validateProductStructure(product);
    if (typeof value !== 'number') throw new TypeError(value + ' is not a Number.');
    var result = product.variants.filter(function(variant) {
        return variant.id === value;
    });
    return result[0] || null;
}
function getVariantFromSerializedArray(product, collection) {
    _validateProductStructure(product);
    // If value is an array of options
    var optionArray = _createOptionArrayFromOptionCollection(product, collection);
    return getVariantFromOptionArray(product, optionArray);
}
function getVariantFromOptionArray(product, options) {
    _validateProductStructure(product);
    _validateOptionsArray(options);
    var result = product.variants.filter(function(variant) {
        return options.every(function(option, index) {
            return variant.options[index] === option;
        });
    });
    return result[0] || null;
}
/**
 * Creates an array of selected options from the object
 * Loops through the project.options and check if the "option name" exist (product.options.name) and matches the target
 * @param {Object} product Product JSON object
 * @param {Array} collection Array of object (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Array} The result of the matched values. (e.g. ['36', 'Black'])
 */ function _createOptionArrayFromOptionCollection(product, collection) {
    _validateProductStructure(product);
    _validateSerializedArray(collection);
    var optionArray = [];
    collection.forEach(function(option) {
        for(var i = 0; i < product.options.length; i++)if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
            optionArray[i] = option.value;
            break;
        }
    });
    return optionArray;
}
/**
 * Check if the product data is a valid JS object
 * Error will be thrown if type is invalid
 * @param {object} product Product JSON object
 */ function _validateProductStructure(product) {
    if (typeof product !== 'object') throw new TypeError(product + ' is not an object.');
    if (Object.keys(product).length === 0 && product.constructor === Object) throw new Error(product + ' is empty.');
}
/**
 * Validate the structure of the array
 * It must be formatted like jQuery's serializeArray()
 * @param {Array} collection Array of object [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }]
 */ function _validateSerializedArray(collection) {
    if (!Array.isArray(collection)) throw new TypeError(collection + ' is not an array.');
    if (collection.length === 0) return [];
    if (collection[0].hasOwnProperty('name')) {
        if (typeof collection[0].name !== 'string') throw new TypeError('Invalid value type passed for name of option ' + collection[0].name + '. Value should be string.');
    } else throw new Error(collection[0] + 'does not contain name key.');
}
/**
 * Validate the structure of the array
 * It must be formatted as list of values
 * @param {Array} collection Array of object (e.g. ['36', 'Black'])
 */ function _validateOptionsArray(options) {
    if (Array.isArray(options) && typeof options[0] === 'object') throw new Error(options + 'is not a valid array of options.');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"2XJxj":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _require = require('@shopify/theme-sections'), register = _require.register;
var Sidebar = function() {
    var initFluidVids = window.Theme.components.Utilities.initFluidVids;
    register('sidebar', {
        // On load
        onLoad: function onLoad() {
            if (typeof initFluidVids === 'function') initFluidVids();
        }
    });
}();
var _default = Sidebar;
exports.default = _default;

},{"@shopify/theme-sections":"9w7jG"}],"96Uhz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _require = require('@shopify/theme-sections'), register = _require.register;
var Slideshow = function() {
    var initFluidVids = window.Theme.components.Utilities.initFluidVids;
    register('slideshow', {
        // Get instance
        getInstance: function getInstance() {
            var _this = this;
            return window.Theme.components.Slideshow.instances.find(function(instance) {
                return _this.container.contains(instance.container);
            });
        },
        // On block select
        onBlockSelect: function onBlockSelect(e) {
            var instance = this.getInstance();
            if (instance) {
                var blockIndex = Array.from(instance.container.querySelectorAll('[data-block]')).findIndex(function(block) {
                    return block == e.target;
                });
                if (blockIndex > -1) {
                    instance.moveToSlide(blockIndex);
                    instance.setAutoplay(false);
                }
            }
        },
        // On load
        onLoad: function onLoad() {
            if (typeof initFluidVids === 'function') initFluidVids();
            window.Theme.components.Slideshow.init();
        }
    });
}();
var _default = Slideshow;
exports.default = _default;

},{"@shopify/theme-sections":"9w7jG"}],"l5KRS":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _require = require('@shopify/theme-sections'), register = _require.register;
var Video = function() {
    var initFluidVids = window.Theme.components.Utilities.initFluidVids;
    register('video', {
        // On load
        onLoad: function onLoad() {
            if (typeof initFluidVids === 'function') initFluidVids();
        }
    });
}();
var _default = Video;
exports.default = _default;

},{"@shopify/theme-sections":"9w7jG"}],"fjiJG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _themeAddresses = require("@shopify/theme-addresses");
// Add component
var Addresses = function() {
    // Set selectors
    var selectors = {
        addressContainer: '[data-address]',
        addressFields: '[data-address-fields]',
        addressToggle: '[data-address-toggle]',
        addressForm: '[data-address-form]',
        addressDeleteForm: '[data-address-delete-form]'
    }; // On load
    var onLoad = function onLoad() {
        var addressForms = document.querySelectorAll(selectors.addressContainer);
        if (addressForms.length) addressForms.forEach(function(addressContainer) {
            initializeAddressForm(addressContainer);
        });
    }; // Initialize address form
    var initializeAddressForm = function initializeAddressForm(container) {
        var addressFields = container.querySelector(selectors.addressFields);
        var addressForm = container.querySelector(selectors.addressForm);
        var deleteForm = container.querySelector(selectors.addressDeleteForm);
        container.querySelectorAll(selectors.addressToggle).forEach(function(button) {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                addressForm.classList.toggle('hidden');
            });
        });
        _themeAddresses.AddressForm(addressFields, 'en');
        if (deleteForm) deleteForm.addEventListener('submit', function(event) {
            var confirmMessage = deleteForm.getAttribute('data-confirm-message');
            if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) event.preventDefault();
        });
    }; // Init
    onLoad(); // Return
    return {
        onLoad: onLoad
    };
}(); // Export
var _default = Addresses;
exports.default = _default;

},{"@shopify/theme-addresses":"9doAZ"}],"9doAZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddressForm", ()=>_addressFormDefault.default
);
var _addressForm = require("./addressForm");
var _addressFormDefault = parcelHelpers.interopDefault(_addressForm);

},{"./addressForm":"V6XqM","@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"V6XqM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loader = require("./loader");
var _helpers = require("./helpers");
var FIELD_REGEXP = /({\w+})/g;
var LINE_DELIMITER = '_';
var INPUT_SELECTORS = {
    lastName: '[name="address[last_name]"]',
    firstName: '[name="address[first_name]"]',
    company: '[name="address[company]"]',
    address1: '[name="address[address1]"]',
    address2: '[name="address[address2]"]',
    country: '[name="address[country]"]',
    zone: '[name="address[province]"]',
    postalCode: '[name="address[zip]"]',
    city: '[name="address[city]"]',
    phone: '[name="address[phone]"]'
};
function AddressForm(rootEl, locale, options) {
    locale = locale || 'en';
    options = options || {
        inputSelectors: {
        }
    };
    var formElements = loadFormElements(rootEl, _helpers.mergeObjects(INPUT_SELECTORS, options.inputSelectors));
    validateElements(formElements);
    return loadShippingCountries(options.shippingCountriesOnly).then(function(shippingCountryCodes) {
        return _loader.loadCountries(locale).then(function(countries) {
            init(rootEl, formElements, filterCountries(countries, shippingCountryCodes));
        });
    });
}
exports.default = AddressForm;
/**
 * Runs when countries have been loaded
 */ function init(rootEl, formElements, countries) {
    populateCountries(formElements, countries);
    var selectedCountry = formElements.country.input ? formElements.country.input.value : null;
    setEventListeners(rootEl, formElements, countries);
    handleCountryChange(rootEl, formElements, selectedCountry, countries);
}
/**
 * Handles when a country change: set labels, reorder fields, populate zones
 */ function handleCountryChange(rootEl, formElements, countryCode, countries) {
    var country = getCountry(countryCode, countries);
    setLabels(formElements, country);
    reorderFields(rootEl, formElements, country);
    populateZones(formElements, country);
}
/**
 * Sets up event listener for country change
 */ function setEventListeners(rootEl, formElements, countries) {
    formElements.country.input.addEventListener('change', function(event) {
        handleCountryChange(rootEl, formElements, event.target.value, countries);
    });
}
/**
 * Reorder fields in the DOM and add data-attribute to fields given a country
 */ function reorderFields(rootEl, formElements, country) {
    var formFormat = country.formatting.edit;
    var countryWrapper = formElements.country.wrapper;
    var afterCountry = false;
    getOrderedField(formFormat).forEach(function(row) {
        row.forEach(function(line) {
            formElements[line].wrapper.dataset.lineCount = row.length;
            if (!formElements[line].wrapper) return;
            if (line === 'country') {
                afterCountry = true;
                return;
            }
            if (afterCountry) rootEl.append(formElements[line].wrapper);
            else rootEl.insertBefore(formElements[line].wrapper, countryWrapper);
        });
    });
}
/**
 * Update labels for a given country
 */ function setLabels(formElements, country) {
    Object.keys(formElements).forEach(function(formElementName) {
        formElements[formElementName].labels.forEach(function(label) {
            label.textContent = country.labels[formElementName];
        });
    });
}
/**
 * Add right countries in the dropdown for a given country
 */ function populateCountries(formElements, countries) {
    var countrySelect = formElements.country.input;
    var duplicatedCountrySelect = countrySelect.cloneNode(true);
    countries.forEach(function(country) {
        var optionElement = document.createElement('option');
        optionElement.value = country.code;
        optionElement.textContent = country.name;
        duplicatedCountrySelect.appendChild(optionElement);
    });
    countrySelect.innerHTML = duplicatedCountrySelect.innerHTML;
    if (countrySelect.dataset.default) countrySelect.value = countrySelect.dataset.default;
}
/**
 * Add right zones in the dropdown for a given country
 */ function populateZones(formElements, country) {
    var zoneEl = formElements.zone;
    if (!zoneEl) return;
    if (country.zones.length === 0) {
        zoneEl.wrapper.dataset.ariaHidden = 'true';
        zoneEl.input.innerHTML = '';
        return;
    }
    zoneEl.wrapper.dataset.ariaHidden = 'false';
    var zoneSelect = zoneEl.input;
    var duplicatedZoneSelect = zoneSelect.cloneNode(true);
    duplicatedZoneSelect.innerHTML = '';
    country.zones.forEach(function(zone) {
        var optionElement = document.createElement('option');
        optionElement.value = zone.code;
        optionElement.textContent = zone.name;
        duplicatedZoneSelect.appendChild(optionElement);
    });
    zoneSelect.innerHTML = duplicatedZoneSelect.innerHTML;
    if (zoneSelect.dataset.default) zoneSelect.value = zoneSelect.dataset.default;
}
/**
 * Will throw if an input or a label is missing from the wrapper
 */ function validateElements(formElements) {
    Object.keys(formElements).forEach(function(elementKey) {
        var element = formElements[elementKey].input;
        var labels = formElements[elementKey].labels;
        if (!element) return;
        if (typeof element !== 'object') throw new TypeError(formElements[elementKey] + ' is missing an input or select.');
        else if (typeof labels !== 'object') throw new TypeError(formElements[elementKey] + ' is missing a label.');
    });
}
/**
 * Given an countryCode (eg. 'CA'), will return the data of that country
 */ function getCountry(countryCode, countries) {
    countryCode = countryCode || 'CA';
    return countries.filter(function(country) {
        return country.code === countryCode;
    })[0];
}
/**
 * Given a format (eg. "{firstName}{lastName}_{company}_{address1}_{address2}_{city}_{country}{province}{zip}_{phone}")
 * will return an array of how the form needs to be formatted, eg.:
 * =>
 * [
 *   ['firstName', 'lastName'],
 *   ['company'],
 *   ['address1'],
 *   ['address2'],
 *   ['city'],
 *   ['country', 'province', 'zip'],
 *   ['phone']
 * ]
 */ function getOrderedField(format) {
    return format.split(LINE_DELIMITER).map(function(fields) {
        var result = fields.match(FIELD_REGEXP);
        if (!result) return [];
        return result.map(function(fieldName) {
            var newFieldName = fieldName.replace(/[{}]/g, '');
            switch(newFieldName){
                case 'zip':
                    return 'postalCode';
                case 'province':
                    return 'zone';
                default:
                    return newFieldName;
            }
        });
    });
}
/**
 * Given a rootEl where all `input`s, `select`s, and `labels` are nested, it
 * will returns all form elements (wrapper, input and labels) of the form.
 * See `FormElements` type for details
 */ function loadFormElements(rootEl, inputSelectors) {
    var elements = {
    };
    Object.keys(INPUT_SELECTORS).forEach(function(inputKey) {
        var input = rootEl.querySelector(inputSelectors[inputKey]);
        elements[inputKey] = input ? {
            wrapper: input.parentElement,
            input: input,
            labels: document.querySelectorAll('[for="' + input.id + '"]')
        } : {
        };
    });
    return elements;
}
/**
 * If shippingCountriesOnly is set to true, will return the list of countries the
 * shop ships to. Otherwise returns null.
 */ function loadShippingCountries(shippingCountriesOnly) {
    if (!shippingCountriesOnly) // eslint-disable-next-line no-undef
    return Promise.resolve(null);
    var response = fetch(location.origin + '/meta.json');
    return response.then(function(res) {
        return res.json();
    }).then(function(meta) {
        // If ships_to_countries has * in the list, it means the shop ships to
        // all countries
        return meta.ships_to_countries.indexOf('*') !== -1 ? null : meta.ships_to_countries;
    }).catch(function() {
        return null;
    });
}
/**
 * Only returns countries that are in includedCountryCodes
 * Returns all countries if no includedCountryCodes is passed
 */ function filterCountries(countries, includedCountryCodes) {
    if (!includedCountryCodes) return countries;
    return countries.filter(function(country) {
        return includedCountryCodes.indexOf(country.code) !== -1;
    });
}

},{"./loader":"gzDV6","./helpers":"3E6Co","@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"gzDV6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadCountries", ()=>loadCountries
);
parcelHelpers.export(exports, "SUPPORTED_LOCALES", ()=>SUPPORTED_LOCALES
);
parcelHelpers.export(exports, "toSupportedLocale", ()=>toSupportedLocale
);
var query = "query countries($locale: SupportedLocale!) {  countries(locale: $locale) {    name    code    labels {      address1      address2      city      company      country      firstName      lastName      phone      postalCode      zone    }    formatting {      edit    }    zones {      name      code    }  }}";
var GRAPHQL_ENDPOINT = 'https://country-service.shopifycloud.com/graphql';
function loadCountries(locale) {
    var response = fetch(GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify({
            query: query,
            operationName: 'countries',
            variables: {
                locale: toSupportedLocale(locale)
            }
        })
    });
    return response.then(function(res) {
        return res.json();
    }).then(function(countries) {
        return countries.data.countries;
    });
}
var DEFAULT_LOCALE = 'EN';
var SUPPORTED_LOCALES = [
    'DA',
    'DE',
    'EN',
    'ES',
    'FR',
    'IT',
    'JA',
    'NL',
    'PT',
    'PT_BR', 
];
function toSupportedLocale(locale) {
    var supportedLocale = locale.replace(/-/, '_').toUpperCase();
    if (SUPPORTED_LOCALES.indexOf(supportedLocale) !== -1) return supportedLocale;
    else if (SUPPORTED_LOCALES.indexOf(supportedLocale.substring(0, 2)) !== -1) return supportedLocale.substring(0, 2);
    else return DEFAULT_LOCALE;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"3E6Co":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeObjects", ()=>mergeObjects
);
function mergeObjects() {
    var to = Object({
    });
    for(var index = 0; index < arguments.length; index++){
        var nextSource = arguments[index];
        if (nextSource) {
            for(var nextKey in nextSource)if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) to[nextKey] = nextSource[nextKey];
        }
    }
    return to;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8FsVl"}],"4FKA8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
// Add component
var Login = function() {
    // Set selectors
    var selectors = {
        loginSection: '[data-login]',
        recoverPasswordSection: '[data-recover-password]',
        recoverPasswordFormSuccess: '[data-recover-password-success]',
        resetPasswordSuccess: '[data-reset-password-success]'
    }; // Init
    var onLoad = function onLoad() {
        if (document.querySelector(selectors.recoverPasswordSection)) {
            checkUrlHash();
            renderResetPasswordSuccess();
        }
    }; // Check URL hash
    var checkUrlHash = function checkUrlHash() {
        if (window.location.hash === '#recover') window.Theme.components.Utilities.toggleElements(selectors.recoverPasswordSection, selectors.loginSection);
    }; // On password reset success
    var renderResetPasswordSuccess = function renderResetPasswordSuccess() {
        if (document.querySelector(selectors.recoverPasswordFormSuccess)) window.Theme.components.Utilities.toggleElements(selectors.resetPasswordSuccess);
    }; // Init
    onLoad(); // Return
    return {
        onLoad: onLoad
    };
}(); // Export
var _default = Login;
exports.default = _default;

},{}]},["gXND3","dA00B"], "dA00B", "parcelRequirec213")

